import { i18n } from '@/plugins/i18n'
import { check } from '@/plugins/helper'
import Vue from '../../main.js'

// DR-1845 code-inspection fix (Minor) - named constants for isAddressSectionInScope
// below, which is the single authoritative scope check for a compliance-driven
// feature (AML screening applicability) - self-documenting code reduces the risk
// of a future edit changing the wrong literal.
const COUNTRY_ID_OTHER_COUNTRIES = 9;
const TXN_TYPE_BANK_TRANSFER = 1;

const getDefaultState = () => {
    return {
        homeCountryName        : "",
        homeCountryId          : 0,
        homeCountryIdd         : "",
        hostCountryName        : "",
        hostCountryId          : 0,
        transactionTypeName    : "",
        transactionTypeId      : 0,
        deliveryMethod         : "",
        deliveryMethodId       : 0,
        dmExternalName         : "",
        beneficiaryId          : 0,
        billCorporationName    : "",
        billCorporationId      : 0,
        billerCode             : "",
        beneficiaryName        : "",
        nickname               : "",
        identificationType     : "",
        idTypeSelect           : "",
        idTypeSelectId         : "",
        identificationNo       : "",
        beneficiaryType        : "",
        beneficiaryTypeId      : 0,
        bankName               : "",
        bankId                 : 0,
        bankNameLabel          : "",
        bankNamePlaceholder    : "",
        bankTypeId             : 0,
        bankBranch             : "",
        bankBranchId           : 0,
        bsbCode                : "",
        bsbCodeLabel           : "",
        iban                   : "",
        swiftCode              : "",
        ifscCode               : "",
        ifscBankBranch         : "",
        sortCode               : "",
        collectionAgent        : "",
        collectionAgentId      : 0,
        collectionPoint        : "",
        collectionPointId      : 0,
        province               : "",
        provinceId             : 0,
        city                   : "",
        cityId                 : 0,
        street                 : "",
        postcode               : "",
        locatingNote           : "",
        landmark               : "",
        bankAccountNo          : "",
        dateOfBirth            : "",
        philGovMemberType      : "",
        philGovMemberTypeId    : 0,
        refNo                  : "",
        audAbn                 : "",
        audAcn                 : "",
        nzbn                   : "",
        // DR-1845 - Beneficiary Country / Town-City (AML screening). Distinct from
        // homeCountryId/homeCountryName, which is the transaction's destination country.
        beneficiaryCountryId      : 0,
        beneficiaryCountryName    : "",
        beneficiaryTownCity       : "",
        addressHardMandatory      : true,  // global toggle (opssystemconfiguration BENEFICIARY_ADDRESS_MANDATORY)
        isCountryAddressMandatory : false, // per-country flag for the currently selected home country
        paymentPurpose         : "",
        paymentPurposeId       : 0,
        paymentPurposeOther    : "",
        homeIDD                : 0,
        homeIDDCode            : "",
        homeNo                 : "",
        mobileIDD              : 0,
        mobileIDDCode          : "",
        mobileNo               : "",
        smsNotification        : false,
        email                  : "",
        emailNotification      : false,

        isDataFilled           : false,
        isbKashTx              : false,
        isDisplayErrorMsg      : false,
        radioErrorMsg          : "",
        beneficiaryNameLabel   : "",
        identificationTypeLabel: "",
        identificationNoLabel  : "",
        bankAccountNoLabel     : "",
        refNoLabel             : "",
        mobileNoLabel          : "",
        emailLabel             : "",
        streetLabel            : "",
        cityLabel              : "",
        landmarkLabel          : "",
        postcodeLabel          : "",
        routerTo               : "",
        statusId               : 0,
        walletNo               : "",

        validateInputState: {
            name                : "",
            value               : false,
        },

        forceRerenderKey: {
            componentPaymentPurposeKey      : 0,
            componentProvinceDetailsKey     : 1000,
            componentAudBtStateKey          : 10000,
            componentAudBtSuburbKey         : 100000,
            componentBTBankNameKey          : 1000000,
            componentBTBankBranchKey        : 10000000,
            componentCollectionKey          : 100000000,
        },

        showPreloaderState: {
            name                : "",
            value               : false,
        },

        showFormSet: {
            billPayment             : false,
            bankTransfer            : false,
            collection              : false,
            provinceDetails         : false,
            doorToDoor              : false,
            kaasiDetails            : false
        },
        showFormInput: {
            billPayment: {
                billerCode              : true
            },
            bankTransfer: {
                bankName                : false,
                bankBranch              : false,
                beneficiaryType         : false,
                bsbCode                 : false,
                iban                    : false,
                ifscCode                : false,
                ifscBankBranch          : false,
                sortCode                : false,
                swiftCode               : false
            },
            provinceDetails: {
                city                    : true,
                postcode                : true,
                province                : true
            },
            root: {
                beneficiaryName         : false,
                nickname                : false,
                identificationType      : false,
                idTypeSelect            : false,
                identificationNo        : false,

                bankAccountNo           : false,
                cnIdentificationNo      : false,
                dob                     : false,
                philGovServiceFullname  : false,
                philGovServiceNickname  : false,
                philGovServiceMemberType: false,
                refNo                   : false,
                walletNo                : false
            },
            kaasiDetails: {
                state                   : false,
                radioButton             : false,
                auBusiness              : false,
                nzBusiness              : false,
            },
            contact: {
                paymentPurpose          : false,
                paymentPurposeOther     : false,
                homeNo                  : false,
                mobileNo                : false,
                email                   : false
            }
        },
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        daValidation : {
            showSheet     : false,
            skipValidation: false,
            message       : "",
            proposedResult: ""
        },
        homeCountryList      : [],
        // DR-1845 - Beneficiary Country dropdown must offer every country (mirrors
        // retail/ops CreateRemittanceDispatchAction's separate staticData.getCountryList()
        // call), NOT homeCountryList (which is scoped to this branch's remittance
        // corridors only).
        allCountryList       : [],
        transactionTypeList  : [],
        bankList             : [],
        bankBranchList       : [],
        idTypeList           : [],
        paymentPurposeList   : [],
        philGovMemberTypeList: [],
        cityList             : [],
        streetList           : [],
        collectionAgentList  : [],
        collectionPointList  : [],
        billCorporationList  : [],
        countryCodeList      : [],
        provinceList         : [],

        isDisplayBillPayment    : false,
        isFormInputValid        : false,
        isCreateBeneficiary     : false,
        isSuburbSelected        : false,
        isValidPostcode         : {},
        allCityList             : [],
        newBeneficiaryId        : 0,
        isAutocomplete          : false,
        isDropdown              : false,
    }
}

const state = getDefaultState()

const getters = {
    showFormSet: (state) => {
        return state.showFormSet
    },
    showFormInput: (state) => {
        return state.showFormInput
    },
    validateInputState: (state) => {
        return state.validateInputState
    },
    forceRerenderKey: (state) => {
        return state.forceRerenderKey
    },
    showPreloaderState: (state) => {
        return state.showPreloaderState
    },
    alertCard: (state) => {
        return state.alertCard
    },
    daValidation: (state) => {
        return state.daValidation
    },
    beneficiaryType: (state) => {
        return state.beneficiaryType
    },
    beneficiaryTypeId: (state) => {
        return state.beneficiaryTypeId
    },
    bankName: (state) => {
        return state.bankName
    },
    bankId: (state) => {
        return state.bankId
    },
    bankNameLabel: (state) => {
        return state.bankNameLabel
    },
    bankNamePlaceholder: (state) => {
        return state.bankNamePlaceholder
    },
    bankTypeId: (state) => {
        return state.bankTypeId
    },
    bankBranch: (state) => {
        return state.bankBranch
    },
    bankBranchId: (state) => {
        return state.bankBranchId
    },
    bsbCode: (state) => {
        return state.bsbCode
    },
    bsbCodeLabel: (state) => {
        return state.bsbCodeLabel
    },
    iban: (state) => {
        return state.iban
    },
    swiftCode: (state) => {
        return state.swiftCode
    },
    ifscCode: (state) => {
        return state.ifscCode
    },
    ifscBankBranch: (state) => {
        return state.ifscBankBranch
    },
    sortCode: (state) => {
        return state.sortCode
    },
    bankList: (state) => {
        return state.bankList
    },
    bankBranchList: (state) => {
        return state.bankBranchList
    },
    homeCountryList: (state) => {
        return state.homeCountryList
    },
    allCountryList: (state) => {
        return state.allCountryList
    },
    homeCountryId: (state) => {
        return state.homeCountryId
    },
    homeCountryIdd: (state) => {
        return state.homeCountryIdd
    },
    homeCountryName: (state) => {
        return state.homeCountryName
    },
    hostCountryId: (state) => {
        return state.hostCountryId
    },
    hostCountryName: (state) => {
        return state.hostCountryName
    },
    transactionTypeList: (state) => {
        return state.transactionTypeList
    },
    transactionTypeId: (state) => {
        return state.transactionTypeId
    },
    transactionTypeName: (state) => {
        return state.transactionTypeName
    },
    deliveryMethod: (state) => {
        return state.deliveryMethod
    },
    deliveryMethodId: (state) => {
        return state.deliveryMethodId
    },
    dmExternalName: (state) => {
        return state.dmExternalName
    },
    beneficiaryId: (state) => {
        return state.beneficiaryId
    },
    homeIDD: (state) => {
        return state.homeIDD
    },
    homeIDDCode: (state) => {
        return state.homeIDDCode
    },
    mobileIDD: (state) => {
        return state.mobileIDD
    },
    mobileIDDCode: (state) => {
        return state.mobileIDDCode
    },
    isbKashTx: (state) => {
        return state.isbKashTx
    },
    isDisplayErrorMsg: (state) => {
        return state.isDisplayErrorMsg
    },
    radioErrorMsg: (state) => {
        return state.radioErrorMsg
    },
    identificationTypeLabel: (state) => {
        return state.identificationTypeLabel
    },
    identificationNoLabel: (state) => {
        return state.identificationNoLabel
    },
    bankAccountNoLabel: (state) => {
        return state.bankAccountNoLabel
    },
    refNoLabel: (state) => {
        return state.refNoLabel
    },
    mobileNoLabel: (state) => {
        return state.mobileNoLabel
    },
    emailLabel: (state) => {
        return state.emailLabel
    },
    beneficiaryName: (state) => {
        return state.beneficiaryName
    },
    beneficiaryNameLabel: (state) => {
        return state.beneficiaryNameLabel
    },
    nickname: (state) => {
        return state.nickname
    },
    identificationType: (state) => {
        return state.identificationType
    },
    idTypeSelect: (state) => {
        return state.idTypeSelect
    },
    idTypeSelectId: (state) => {
        return state.idTypeSelectId
    },
    idTypeList: (state) => {
        return state.idTypeList
    },
    identificationNo: (state) => {
        return state.identificationNo
    },
    bankAccountNo: (state) => {
        return state.bankAccountNo
    },
    walletNo: (state) => {
        return state.walletNo
    },
    paymentPurpose: (state) => {
        return state.paymentPurpose
    },
    paymentPurposeId: (state) => {
        return state.paymentPurposeId
    },
    paymentPurposeOther: (state) => {
        return state.paymentPurposeOther
    },
    paymentPurposeList: (state) => {
        return state.paymentPurposeList
    },
    dateOfBirth: (state) => {
        return state.dateOfBirth
    },
    philGovMemberType: (state) => {
        return state.philGovMemberType
    },
    philGovMemberTypeId: (state) => {
        return state.philGovMemberTypeId
    },
    philGovMemberTypeList: (state) => {
        return state.philGovMemberTypeList
    },
    refNo: (state) => {
        return state.refNo
    },
    city: (state) => {
        return state.city
    },
    cityId: (state) => {
        return state.cityId
    },
    cityList: (state) => {
        return state.cityList
    },
    allCityList: (state) => {
        return state.allCityList
    },
    streetList: (state) => {
        return state.streetList
    },
    collectionAgent: (state) => {
        return state.collectionAgent
    },
    collectionAgentId: (state) => {
        return state.collectionAgentId
    },
    collectionAgentList: (state) => {
        return state.collectionAgentList
    },
    collectionPoint: (state) => {
        return state.collectionPoint
    },
    collectionPointId: (state) => {
        return state.collectionPointId
    },
    collectionPointList: (state) => {
        return state.collectionPointList
    },
    billCorporationId: (state) => {
        return state.billCorporationId
    },
    billCorporationName: (state) => {
        return state.billCorporationName
    },
    billerCode: (state) => {
        return state.billerCode
    },
    billCorporationList: (state) => {
        return state.billCorporationList
    },
    countryCodeList: (state) => {
        return state.countryCodeList
    },
    provinceList: (state) => {
        return state.provinceList
    },
    province: (state) => {
        return state.province
    },
    provinceId: (state) => {
        return state.provinceId
    },
    street: (state) => {
        return state.street
    },
    postcode: (state) => {
        return state.postcode
    },
    locatingNote: (state) => {
        return state.locatingNote
    },
    landmark: (state) => {
        return state.landmark
    },
    audAbn: (state) => {
        return state.audAbn
    },
    audAcn: (state) => {
        return state.audAcn
    },
    nzbn: (state) => {
        return state.nzbn
    },
    beneficiaryCountryId: (state) => {
        return state.beneficiaryCountryId
    },
    beneficiaryCountryName: (state) => {
        return state.beneficiaryCountryName
    },
    beneficiaryTownCity: (state) => {
        return state.beneficiaryTownCity
    },
    addressHardMandatory: (state) => {
        return state.addressHardMandatory
    },
    isCountryAddressMandatory: (state) => {
        return state.isCountryAddressMandatory
    },
    // DR-1845 - single source of truth for whether the Beneficiary Country /
    // Town-City section applies to the current corridor: mirrors retail/ops
    // CreateRemittanceDispatchAction's beneficiaryCountryMandatory formula
    // exactly (Customer#isCountryAddressMandatory OR "Other Countries" (id 9)
    // on a bank transfer). Shared by beneficiary-address-details.vue (v-if on
    // the section) and the create/modify pages' soft-mandatory confirm popup,
    // so both stay in lockstep with a single formula.
    isAddressSectionInScope: (state) => {
        return state.isCountryAddressMandatory
            || (state.homeCountryId == COUNTRY_ID_OTHER_COUNTRIES && state.transactionTypeId == TXN_TYPE_BANK_TRANSFER);
    },
    isValidBeneficiaryCountry: (state) => {
        return state.isValidBeneficiaryCountry
    },
    isValidBeneficiaryTownCity: (state) => {
        return state.isValidBeneficiaryTownCity
    },
    homeNo: (state) => {
        return state.homeNo
    },
    mobileNo: (state) => {
        return state.mobileNo
    },
    smsNotification: (state) => {
        return state.smsNotification
    },
    email: (state) => {
        return state.email
    },
    emailNotification: (state) => {
        return state.emailNotification
    },
    routerTo: (state) => {
        return state.routerTo
    },
    newBeneficiaryId: (state) => {
        return state.newBeneficiaryId
    },
    isDisplayBillPayment: (state) => {
        return state.isDisplayBillPayment
    },
    isDisplayBankTransfer: (state) => {
        return state.isDisplayBankTransfer
    },
    isDisplayCollection: (state) => {
        return state.isDisplayCollection
    },
    isDisplayProvinceDetails: (state) => {
        return state.isDisplayProvinceDetails
    },
    isDisplayDoorToDoor: (state) => {
        return state.isDisplayDoorToDoor
    },
    isDisplayKaasiDetails: (state) => {
        return state.isDisplayKaasiDetails
    },
    isDisplayBillerCode: (state) => {
        return state.isDisplayBillerCode
    },
    isDisplayBank: (state) => {
        return state.isDisplayBank
    },
    isDisplayBankBranch: (state) => {
        return state.isDisplayBankBranch
    },
    isDisplayBeneficiaryType: (state) => {
        return state.isDisplayBeneficiaryType
    },
    isDisplayBsbCode: (state) => {
        return state.isDisplayBsbCode
    },
    isDisplayIban: (state) => {
        return state.isDisplayIban
    },
    isDisplayIfscCode: (state) => {
        return state.isDisplayIfscCode
    },
    isDisplayIfscBankBranch: (state) => {
        return state.isDisplayIfscBankBranch
    },
    isDisplaySortcode: (state) => {
        return state.isDisplaySortcode
    },
    isDisplaySwiftCode: (state) => {
        return state.isDisplaySwiftCode
    },
    isDisplayCity: (state) => {
        return state.isDisplayCity
    },
    isDisplayPostcode: (state) => {
        return state.isDisplayPostcode
    },
    isDisplayProvince: (state) => {
        return state.isDisplayProvince
    },
    isDisplayBeneficiaryName: (state) => {
        return state.isDisplayBeneficiaryName
    },
    isDisplayNickname: (state) => {
        return state.isDisplayNickname
    },
    isDisplayIdType: (state) => {
        return state.isDisplayIdType
    },
    isDisplayIdTypeSelect: (state) => {
        return state.isDisplayIdTypeSelect
    },
    isDisplayIdNo: (state) => {
        return state.isDisplayIdNo
    },
    isDisplayAccountNo: (state) => {
        return state.isDisplayAccountNo
    },
    isDisplayWalletNo: (state) => {
        return state.isDisplayWalletNo
    },
    isDisplayCnIdNo: (state) => {
        return state.isDisplayCnIdNo
    },
    isDisplayDateOfBirth: (state) => {
        return state.isDisplayDateOfBirth
    },
    isDisplayPhilGovFullName: (state) => {
        return state.isDisplayPhilGovFullName
    },
    isDisplayPhilGovNickname: (state) => {
        return state.isDisplayPhilGovNickname
    },
    isDisplayPhilGovMemberType: (state) => {
        return state.isDisplayPhilGovMemberType
    },
    isDisplayRefNo: (state) => {
        return state.isDisplayRefNo
    },
    isDisplayAudBtState: (state) => {
        return state.isDisplayAudBtState
    },
    isDisplayAudRadio: (state) => {
        return state.isDisplayAudRadio
    },
    isDisplayAudBusiness: (state) => {
        return state.isDisplayAudBusiness
    },
    isDisplayNzBusiness: (state) => {
        return state.isDisplayNzBusiness
    },
    isDisplayPaymentPurpose: (state) => {
        return state.isDisplayPaymentPurpose
    },
    isDisplayPaymentPurposeOther: (state) => {
        return state.isDisplayPaymentPurposeOther
    },
    isDisplayHomeNo: (state) => {
        return state.isDisplayHomeNo
    },
    isDisplayMobileNo: (state) => {
        return state.isDisplayMobileNo
    },
    isDisplayEmail: (state) => {
        return state.isDisplayEmail
    },
    streetLabel: (state) => {
        return state.streetLabel
    },
    cityLabel: (state) => {
        return state.cityLabel
    },
    landmarkLabel: (state) => {
        return state.landmarkLabel
    },
    postcodeLabel: (state) => {
        return state.postcodeLabel
    },
    isValidBillCorp: (state) => {
        return state.isValidBillCorp
    },
    isValidBeneficiaryName: (state) => {
        return state.isValidBeneficiaryName
    },
    isValidNickname: (state) => {
        return state.isValidNickname
    },
    isValidIdType: (state) => {
        return state.isValidIdType
    },
    isValidIdTypeSelect: (state) => {
        return state.isValidIdTypeSelect
    },
    isValidIdNo: (state) => {
        return state.isValidIdNo
    },
    isValidBeneficiaryType: (state) => {
        return state.isValidBeneficiaryType
    },
    isValidBank: (state) => {
        return state.isValidBank
    },
    isValidBankBranch: (state) => {
        return state.isValidBankBranch
    },
    isValidBsbcode: (state) => {
        return state.isValidBsbcode
    },
    isValidIban: (state) => {
        return state.isValidIban
    },
    isValidSwiftcode: (state) => {
        return state.isValidSwiftcode
    },
    isValidIfsccode: (state) => {
        return state.isValidIfsccode
    },
    isValidIfscBankBranch: (state) => {
        return state.isValidIfscBankBranch
    },
    isValidSortcode: (state) => {
        return state.isValidSortcode
    },
    isValidCollectionAgent: (state) => {
        return state.isValidCollectionAgent
    },
    isValidCollectionPoint: (state) => {
        return state.isValidCollectionPoint
    },
    isValidProvince: (state) => {
        return state.isValidProvince
    },
    isValidCity: (state) => {
        return state.isValidCity
    },
    isValidStreet: (state) => {
        return state.isValidStreet
    },
    isValidPostcode: (state) => {
        return state.isValidPostcode
    },
    isValidAccountNo: (state) => {
        return state.isValidAccountNo
    },
    isValidWalletNo: (state) => {
        return state.isValidWalletNo
    },
    isValidDateOfBirth: (state) => {
        return state.isValidDateOfBirth
    },
    isValidPhilGovMemberType: (state) => {
        return state.isValidPhilGovMemberType
    },
    isValidRefNo: (state) => {
        return state.isValidRefNo
    },
    isValidAbn: (state) => {
        return state.isValidAbn
    },
    isValidAcn: (state) => {
        return state.isValidAcn
    },
    isValidNzbn: (state) => {
        return state.isValidNzbn
    },
    isValidPaymentPurpose: (state) => {
        return state.isValidPaymentPurpose
    },
    isValidHomeNo: (state) => {
        return state.isValidHomeNo
    },
    isValidMobileNo: (state) => {
        return state.isValidMobileNo
    },
    isValidEmail: (state) => {
        return state.isValidEmail
    },
    isValidCheckOnlySpecial: (state) => {
        return state.isValidCheckOnlySpecial
    },
    isFormInputValid: (state) => {
        return state.isFormInputValid
    },
    isCreateBeneficiary: (state) => {
        return state.isCreateBeneficiary
    },
    isSuburbSelected: (state) => {
        return state.isSuburbSelected
    },
    isAutocomplete: (state) => {
        return state.isAutocomplete
    },
    isDropdown: (state) => {
        return state.isDropdown
    },
    isValidLandmark: (state) => {
        return state.isValidLandmark
    },
}

const actions = {
    resetBeneficiaryState ({ commit }) {
        commit('resetBeneficiaryState')
    },

    displayBillPayment({ commit }, params) {
        let isDisplay     = false
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false

        // BILL PAYMENT
        isDisplay = isBillPayment ? true : false

        commit('loadIsDisplayBillPayment', isDisplay);
    },

    displayBankTransfer({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || (params.dmId == 1 && params.bankTypeId == 0)) ? true : false
        let isCashCard     = (params.txTypeId == 5 || params.txTypeId == 103 || params.dmId == 6) ? true : false
        let isUpi          = (params.txTypeId == 6 || params.dmId == 9) ? true : false
        let isPhilGov      = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false
        let isWallet       = (params.txTypeId == 102 || (params.dmId == 1 && params.bankTypeId == 2)) ? true : false

        // BANK TRANSFER || CASH CARD || UPI || PHIL GOV || WALLET
        isDisplay = (isBankTransfer || isCashCard || isUpi || isPhilGov || isWallet) ? true : false

        commit('loadIsDisplayBankTransfer', isDisplay);
    },

    displayCollection({ commit }, params) {
        let isDisplay    = false
        let isCollection = (params.txTypeId == 3 || params.dmId == 3) ? true : false

        // COLLECTION
        isDisplay = isCollection ? true : false

        commit('loadIsDisplayCollection', isDisplay);
    },

    displayProvinceDetails({ commit }, params) {
        let isDisplay    = false
        let isDoorToDoor = (params.txTypeId == 2 || params.dmId == 4) ? true : false
        let isCollection = (params.txTypeId == 3 || params.dmId == 3) ? true : false
        let isBankTransfer     = (params.txTypeId == 1 || (params.dmId == 1 && params.bankTypeId == 0)) ? true : false

        // DOOR TO DOOR || (BANK TRANSFER && 106 - JAPAN) ||(COLLECTION && (99 - INDONESIA || (167 - PHILIPPINES && (1104 - BDO/RURAL BANK/SM FOREX || 2200 - PALAWAN PAWNSHOP))))
        if(isDoorToDoor || (isBankTransfer && params.countryId == 106) || (isCollection && (params.countryId == 99 || (params.countryId == 167 && (params.caId == 1104 || params.caId == 2200))))) {
            isDisplay = true;
        }

        commit('loadIsDisplayProvinceDetails', isDisplay);
    },

    displayDoorToDoor({ commit }, params) {
        let isDisplay    = false
        let isDoorToDoor = (params.txTypeId == 2 || params.dmId == 4) ? true : false

        // DOOR TO DOOR
        isDisplay = isDoorToDoor ? true : false

        commit('loadIsDisplayDoorToDoor', isDisplay);
    },

    displayKaasiDetails({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && (13 - AUSTRALIA || 152 - NEW ZEALAND)
        isDisplay = (isBankTransfer && (params.countryId == 13 || params.countryId == 152)) ? true : false

        commit('loadIsDisplayKaasiDetails', isDisplay);
    },

    displayBillerCode({ commit }, params) {
        let isDisplay     = false
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false

        // BILL PAYMENT && 13 - AUSTRALIA
        isDisplay = (isBillPayment && params.countryId == 13) ? true : false

        commit('loadIsDisplayBillerCode', isDisplay);
    },

    displayBank({ commit }, params) {
        let isDisplay          = false
        let displayLabel       = ""
        let displayPlaceholder = ""
        let isBankTransfer     = (params.txTypeId == 1 || (params.dmId == 1 && params.bankTypeId == 0)) ? true : false
        let isCashCard         = (params.txTypeId == 5 || params.txTypeId == 103 || params.dmId == 6) ? true : false
        let isPhilGov          = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false
        let isWallet           = (params.txTypeId == 102 || (params.dmId == 1 && params.bankTypeId == 2)) ? true : false

        // (BANK TRANSFER && (18 - BANGLADESH || 44 - CHINA || 95 - HONG KONG S.A.R. || 98 - INDIA || 99 - INDONESIA || 106 - JAPAN || 111 - S.KOREA
        //         || 128 - MALAYSIA || 145 - MYANMAR || 148 - NEPAL || 161 - PAKISTAN || 167 - PHILIPPINES || 197 - SRI LANKA || 205 - TAIWAN || 208 - THAILAND
        //         || 221 - UNITED KINGDOM || 222 - UNITED STATES  || 228 - VIETNAM || 236 - VIETNAM (USD) || 237 - CAMBODIA || 238 - EUROPEAN UNION (EU) || 253 - AMERICA))
        // || (CASH CARD || BKASH) || PHIL GOV SERVICE || WALLET
        if((isBankTransfer && (params.countryId == 18 || params.countryId == 44 || params.countryId == 95 || params.countryId == 98 || params.countryId == 99
                || params.countryId == 106 || params.countryId == 111 || params.countryId == 128 || params.countryId == 145 || params.countryId == 148
                || params.countryId == 161 || params.countryId == 167 || params.countryId == 197 || params.countryId == 205 || params.countryId == 208
                || params.countryId == 221 || params.countryId == 222 || params.countryId == 228 || params.countryId == 236 || params.countryId == 237
                || params.countryId == 238 || params.countryId == 253))
            || isCashCard || isPhilGov || isWallet
        ) {
            isDisplay = true;
        }

        // PHIL GOV SERVICE
        if(isPhilGov) {
            displayLabel       = i18n.t('beneficiary-gov-service-type');
            displayPlaceholder = i18n.t('beneficiary-select-gov-service-type');
        }
        // WALLET
        else if(isWallet) {
            displayLabel       = i18n.t('beneficiary-wallet-name');
            displayPlaceholder = i18n.t('beneficiary-select-wallet');
        }
        else {
            displayLabel       = i18n.t('beneficiary-bank');
            displayPlaceholder = i18n.t('beneficiary-select-bank');
        }

        const result = {
            isDisplay  : isDisplay,
            label      : displayLabel,
            placeholder: displayPlaceholder
        }
        commit('loadIsDisplayBank', result);
    },

    displayBankBranch({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || (params.dmId == 1 && params.bankTypeId == 0)) ? true : false

        // (BANK TRANSFER && (18 - BANGLADESH || 44 - CHINA || 95 - HONG KONG S.A.R. || 106 - JAPAN || 111 - S.KOREA || 145 - MYANMAR
        //    || 148 - NEPAL || 161 - PAKISTAN || 197 - SRI LANKA || 208 - THAILAND || 222 - UNITED STATES || 236 - VIETNAM (USD) || 237 - CAMBODIA)
        if(isBankTransfer && (params.countryId == 18 || params.countryId == 44 || params.countryId == 95 || params.countryId == 106 || params.countryId == 111
            || params.countryId == 145 || params.countryId == 148 || params.countryId == 161 || params.countryId == 197 || params.countryId == 208
            || params.countryId == 222 || params.countryId == 236 || params.countryId == 237
        )
        ) {
            isDisplay = true;
        }

        commit('loadIsDisplayBankBranch', isDisplay);
    },

    displayBeneficiaryType({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false
        let isUpi          = (params.txTypeId == 6 || params.dmId == 9) ? true : false

        // (BANK TRANSFER && 98 - INDIA) || 6 - UPI
        if((isBankTransfer && params.countryId == 98) || isUpi) {
            isDisplay = true;
        }

        commit('loadIsDisplayBeneficiaryType', isDisplay);
    },

    displayBsbCode({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false
        let displayLabel   = params.countryId == 152 ? i18n.t('beneficiary-bank-code') : i18n.t('beneficiary-bsb-code')

        // BANK TRANSFER && (13 - AUSTRALIA || 152 - NEW ZEALAND)
        isDisplay = (isBankTransfer && (params.countryId == 13 || params.countryId == 152)) ? true : false
        
        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayBsbCode', result);
    },

    displayIban({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && (221 - United Kingdom || 238 - EUROPEAN UNION (EU))
        isDisplay = (isBankTransfer && (params.countryId == 221 || params.countryId == 238)) ? true : false

        commit('loadIsDisplayIban', isDisplay);
    },

    displayIfscCode({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && 98 - INDIA
        isDisplay = (isBankTransfer && params.countryId == 98) ? true : false

        commit('loadIsDisplayIfscCode', isDisplay);
    },

    displayIfscBankBranch({ commit }) {
        let isDisplay      = false
        // let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && 98 - INDIA
        // isDisplay = (isBankTransfer && params.countryId == 98) ? true : false

        commit('loadIsDisplayIfscBankBranch', isDisplay);
    },

    displaySortCode({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && 221 - UNITED KINGDOM
        isDisplay = (isBankTransfer && params.countryId == 221) ? true : false

        commit('loadIsDisplaySortCode', isDisplay);
    },

    displaySwiftCode({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && (238 - EUROPEAN UNION (EU) || 253 - AMERICA)
        isDisplay = (isBankTransfer && (params.countryId == 238 || params.countryId == 253)) ? true : false

        commit('loadIsDisplaySwiftCode', isDisplay);
    },

    displayCity({ commit }, params) {
        let isDisplay    = false
        let isCollection = (params.txTypeId == 3 || params.dmId == 3) ? true : false

        // NOT COLLECTION && NOT 99 - INDONESIA
        isDisplay = !(isCollection && params.countryId == 99) ? true : false

        commit('loadIsDisplayCity', isDisplay);
    },

    displayPostcode({ commit }, params) {
        let isDisplay    = false
        let isCollection = (params.txTypeId == 3 || params.dmId == 3) ? true : false

        // NOT COLLECTION && NOT 99 - INDONESIA
        isDisplay = !(isCollection && params.countryId == 99) ? true : false

        commit('loadIsDisplayPostcode', isDisplay);
    },

    displayProvince({ commit }, params) {
        let isDisplay    = false
        let isCollection = (params.txTypeId == 3 || params.dmId == 3) ? true : false

        // NOT COLLECTION && NOT 99 - INDONESIA
        isDisplay = !(isCollection && params.countryId == 99) ? true : false

        commit('loadIsDisplayProvince', isDisplay);
    },

    displayBeneficiaryName({ commit }, params) {
        let isDisplay     = false
        let displayLabel  = ""
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false
        let isPhilGov     = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // NOT PHIL GOV SERVICE
        isDisplay = !isPhilGov ? true : false
        // BILL PAYMENT
        displayLabel = isBillPayment ? i18n.t('beneficiary-bill-account-name') : i18n.t('beneficiary-fullname');

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayBeneficiaryName', result);
    },

    displayNickname({ commit }, params) {
        let isDisplay = false
        let isPhilGov = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // NOT PHIL GOV SERVICE
        isDisplay = !isPhilGov ? true : false

        commit('loadIsDisplayNickname', isDisplay);
    },

    displayIdType({ commit }, params) {
        let isDisplay    = false
        let displayLabel = ""
        let isDoorToDoor = (params.txTypeId == 2 || params.dmId == 4) ? true : false
        let isCollection = (params.txTypeId == 3 || params.dmId == 3) ? true : false

        // DOOR TO DOOR
        //    || (COLLECTION && (95 - HONG KONG S.A.R. || 99 - INDONESIA || 145 - MYANMAR || 167 - PHILIPPINES || 228 - VIETNAM || 236 - VIETNAM USD))
        if(isDoorToDoor
            || (isCollection && (params.countryId == 95 || params.countryId == 99 || params.countryId == 145
                || params.countryId == 167 || params.countryId == 228 || params.countryId == 236))
        ) {
            isDisplay = true;
        }

        // COLLECTION && 167 - PHILIPPINES
        displayLabel = (isCollection && params.countryId == 167) ? i18n.t('beneficiary-beneficiary-id-type-optional') : i18n.t('beneficiary-beneficiary-id-type');

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayIdType', result);
    },

    displayIdTypeSelect({ commit }, params) {
        let isDisplay    = false
        let isCollection = (params.txTypeId == 3 || params.dmId == 3) ? true : false

        // COLLECTION && (18 - BANGLADESH || 98 - INDIA || 197 - SRI LANKA))
        if(isCollection && (params.countryId == 18 || params.countryId == 98 || params.countryId == 197)) {
            isDisplay = true;
        }

        commit('loadIsDisplayIdTypeSelect', isDisplay);
    },

    displayIdNo({ commit }, params) {
        let isDisplay      = false
        let displayLabel   = ""
        let isBankTransfer = (params.txTypeId == 1 || (params.dmId == 1 && params.bankTypeId == 0)) ? true : false
        let isDoorToDoor   = (params.txTypeId == 2 || params.dmId == 4) ? true : false
        let isCollection   = (params.txTypeId == 3 || params.dmId == 3) ? true : false

        //  DOOR TO DOOR || COLLECTION || (BANK TRANSFER && 205 - TAIWAN)
        isDisplay = (isDoorToDoor || isCollection || (isBankTransfer && params.countryId == 205)) ? true : false;

        // COLLECTION && 167 - PHILIPPINES
        displayLabel = (isCollection && params.countryId == 167) ? i18n.t('beneficiary-beneficiary-id-no-optional') : i18n.t('beneficiary-beneficiary-id-no');

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayIdNo', result);
    },

    displayAccountNo({ commit }, params) {
        let isDisplay      = false
        let displayLabel   = ""
        let isBankTransfer = (params.txTypeId == 1 || (params.dmId == 1 && params.bankTypeId == 0)) ? true : false
        let isCashCard     = (params.txTypeId == 5 || params.txTypeId == 103 || params.dmId == 6) ? true : false
        let isBillPayment  = (params.txTypeId == 4 || params.dmId == 0) ? true : false
        let isUpi          = (params.txTypeId == 6 || params.dmId == 9) ? true : false
        let isPhilGov      = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false
        let isWallet       = (params.txTypeId == 102 || (params.dmId == 1 && params.bankTypeId == 2)) ? true : false

        // BANK TRANSFER || CASH CARD || BILL PAYMENT || UPI || PHIL GOV || WALLET
        isDisplay = (isBankTransfer || isCashCard || isBillPayment || isUpi || isPhilGov || isWallet) ? true : false

        // BANK TRANSFER
        if(isBankTransfer) {
            displayLabel = i18n.t('beneficiary-bank-account-no')
        }
        // CASH CARD
        else if(isCashCard) {
            // 18 - BANGLADESH
            if(params.countryId == 18) {
                displayLabel = i18n.t('beneficiary-bkash-no')
            }
            // 167 - PHILIPPINES
            else if(params.countryId == 167) {
                displayLabel = i18n.t('beneficiary-cash-card-no')
            }
        }
        // BILL PAYMENT
        else if(isBillPayment) {
            displayLabel = i18n.t('beneficiary-bill-account-no')
        }
        // UPI
        else if(isUpi) {
            displayLabel = i18n.t('beneficiary-virtual-payment-address')
        }
        // PHIL GOV
        else if(isPhilGov) {
            // 4520 - PhilHealth
            if(params.bankId == 4520) {
                displayLabel = i18n.t('beneficiary-phil-health-number')
            }
            // 4521 - Pag-IBIG
            else if(params.bankId == 4521) {
                displayLabel = i18n.t('beneficiary-pag-ibig-number')
            }
            // 4522 - SSS
            else if(params.bankId == 4522) {
                displayLabel = i18n.t('beneficiary-sss-number')
            }
        }
        // WALLET
        else if(isWallet) {
            displayLabel = i18n.t('beneficiary-mobile-topup-no')
        }

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }

        if(isWallet){
            commit('loadIsDisplayWalletNo', result);
        }else{
            commit('loadIsDisplayAccountNo', result);
        }
    },

    displayCnIdNo({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && 44 - CHINA
        isDisplay = (isBankTransfer && params.countryId == 44) ? true : false

        commit('loadIsDisplayCnIdNo', isDisplay);
    },

    displayDateOfBirth({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && 44 - CHINA
        isDisplay = (isBankTransfer && params.countryId == 44) ? true : false

        commit('loadIsDisplayDateOfBirth', isDisplay);
    },

    displayPhilGovFullName({ commit }, params) {
        let isDisplay = false
        let isPhilGov = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // PHIL GOV
        isDisplay = isPhilGov ? true : false

        commit('loadIsDisplayPhilGovFullName', isDisplay);
    },

    displayPhilGovNickname({ commit }, params) {
        let isDisplay = false
        let isPhilGov = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // PHIL GOV
        isDisplay = isPhilGov ? true : false

        commit('loadIsDisplayPhilGovNickname', isDisplay);
    },

    displayPhilGovMemberType({ commit }, params) {
        let isDisplay = false
        let isPhilGov = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // PHIL GOV
        isDisplay = isPhilGov ? true : false

        commit('loadIsDisplayPhilGovMemberType', isDisplay);
    },

    displayRefNo({ commit }, params) {
        let isDisplay     = false
        let displayLabel  = ""
        let isDoorToDoor  = (params.txTypeId == 2 || params.dmId == 4) ? true : false
        let isCollection  = (params.txTypeId == 3 || params.dmId == 3) ? true : false
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false

        // DOOR TO DOOR || COLLECTION || (BILL PAYMENT && 167 - PHILIPPINES)
        isDisplay = (isDoorToDoor || isCollection || (isBillPayment && params.countryId == 167)) ? true : false

        // COLLECTION
        if(isCollection) {
            // 95 - HONG KONG S.A.R.
            if(params.countryId == 95) {
                displayLabel = i18n.t('beneficiary-ref-no-col-point')
            }
            // 99 - INDONESIA
            else if(params.countryId == 99) {
                displayLabel = i18n.t('beneficiary-ref-no-optional')
            } else {
                displayLabel = i18n.t('beneficiary-ref-no-col-point-optional')
            }
        } else if(isBillPayment) {
            displayLabel = i18n.t('beneficiary-ref-no-bill-payment')
        } else {
            displayLabel = i18n.t('beneficiary-ref-no-col-point-optional')
        }

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayRefNo', result);
    },

    displayAudBtState({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && 13 - AUSTRALIA
        isDisplay = (isBankTransfer && params.countryId == 13) ? true : false

        commit('loadIsDisplayAudBtState', isDisplay);
    },

    displayAudRadio({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && (13 - AUSTRALIA || 152 - NEW ZEALAND)
        isDisplay = (isBankTransfer && (params.countryId == 13 || params.countryId == 152)) ? true : false

        commit('loadIsDisplayAudRadio', isDisplay);
    },

    displayAudBusiness({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && 13 - AUSTRALIA && 2 - BUSINESS
        isDisplay = (isBankTransfer && params.countryId == 13 && params.beneTypeId == 2) ? true : false

        commit('loadIsDisplayAudBusiness', isDisplay);
    },

    displayNzBusiness({ commit }, params) {
        let isDisplay      = false
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && 152 - NEW ZEALAND && 2 - BUSINESS
        isDisplay = (isBankTransfer && params.countryId == 152 && params.beneTypeId == 2) ? true : false

        commit('loadIsDisplayNzBusiness', isDisplay)
    },

    displayPaymentPurpose({ commit }, params) {
        let isDisplay     = false
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false
        let isPhilGov     = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // NOT BILL PAYMENT && NOT PHIL GOV
        isDisplay = (!isBillPayment && !isPhilGov) ? true : false

        commit('loadIsDisplayPaymentPurpose', isDisplay);
    },

    displayPaymentPurposeOther({ commit }, params) {
        let isDisplay     = false
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false
        let isPhilGov     = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // NOT BILL PAYMENT && NOT PHIL GOV && -1 - OTHERS
        isDisplay = (!isBillPayment && !isPhilGov && params.ppId == -1) ? true : false

        commit('loadIsDisplayPaymentPurposeOther', isDisplay);
    },

    displayHomeNo({ commit }, params) {
        let isDisplay = false
        let isPhilGov = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // NOT PHIL GOV
        isDisplay = !isPhilGov ? true : false

        commit('loadIsDisplayHomeNo', isDisplay);
    },

    displayMobileNo({ commit }, params) {
        let isDisplay      = false
        let displayLabel   = ""
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false
        let isDoorToDoor   = (params.txTypeId == 2 || params.dmId == 4) ? true : false
        let isCollection   = (params.txTypeId == 3 || params.dmId == 3) ? true : false
        let isPhilGov      = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // NOT PHIL GOV
        isDisplay = !isPhilGov ? true : false

        // (BANK TRANSFER && (13 - AUSTRALIA || 111 - S.KOREA || 228 - VIETNAM)) || DOOR TO DOOR || COLLECTION
        if((isBankTransfer && (params.countryId == 13 || params.countryId == 111 || params.countryId == 228))
            || isDoorToDoor || isCollection
        ) {
            displayLabel = i18n.t('beneficiary-mobile-no')
        } else {
            displayLabel = i18n.t('beneficiary-mobile-no-optional')
        }

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayMobileNo', result);
    },

    displayEmail({ commit }, params) {
        let isDisplay    = false
        let displayLabel = ""
        let isPhilGov    = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        // NOT PHIL GOV && (NOT 4521 - Pag-IBIG || NOT 4522 - SSS)
        isDisplay = !(isPhilGov && (params.bankId == 4521 || params.bankId == 4522)) ? true : false

        // PHIL GOV && 4520 - PhilHealth
        displayLabel = (isPhilGov && params.bankId == 4520) ? i18n.t('beneficiary-email') : i18n.t('beneficiary-email-optional')

        const result = {
            isDisplay: isDisplay,
            label    : displayLabel,
        }
        commit('loadIsDisplayEmail', result);
    },

    changeStreetLabel({ commit } , params) {
        let displayLabel = ""
        let isCollection = (params.txTypeId == 3 || params.dmId == 3) ? true : false

        // COLLECTION && 99 - INDONESIA
        displayLabel = (isCollection && params.countryId == 99) ? i18n.t('beneficiary-beneficiary-address') : i18n.t('beneficiary-street')

        commit('loadStreetLabel', displayLabel);
    },

    changeCityLabel({ commit } , params) {
        let displayLabel = ""
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && 106 - JAPAN
        displayLabel = (isBankTransfer && params.countryId == 106) ? i18n.t('beneficiary-district') : i18n.t('beneficiary-city')

        commit('loadCityLabel', displayLabel);
    },

    changeLandmarkLabel({ commit } , params) {
        let displayLabel = ""
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && 106 - JAPAN
        displayLabel = (isBankTransfer && params.countryId == 106) ? i18n.t('general-text-details') : i18n.t('beneficiary-landmark-optional')

        commit('loadLandmarkLabel', displayLabel);
    },

    changePostcodeLabel({ commit } , params) {
        let displayLabel = ""
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false

        // BANK TRANSFER && 106 - JAPAN
        displayLabel = (isBankTransfer && params.countryId == 106) ? i18n.t('beneficiary-postcode') : i18n.t('beneficiary-postcode-optional')

        commit('loadPostcodeLabel', displayLabel);
    },

    validateBillCorp({ commit }, value) {
        console.log("validate bill corp : "+value)
        let billCorpId = value;
        let inputState = (billCorpId > 0) ? true : i18n.t('beneficiary-bill-corp-error');
        commit('loadIsValidBillCorp', inputState);
    },

    validateBeneficiaryName({ commit, dispatch }, params) {
        let beneName      = params.name != undefined ? params.name : '';
        let isValidInput  = true;
        let inputState    = "";
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false

        let msg1 = i18n.t('beneficiary-fullname-error1');
        let msg2 = i18n.t('beneficiary-fullname-error2');
        let msg3 = i18n.t('beneficiary-fullname-error3');
        // 4 - BILL PAYMENT
        if(isBillPayment) {
            msg1 = i18n.t('beneficiary-bill-account-name-error1');
            msg2 = i18n.t('beneficiary-bill-account-name-error1');
            msg3 = i18n.t('beneficiary-bill-account-name-error1');
        }

        dispatch('checkPreventOnlySpecial', beneName);
        let chkSpcResult = this.state.beneficiary.isValidCheckOnlySpecial;
        if(chkSpcResult < 0) {
            isValidInput = false;
            switch(chkSpcResult) {
                case -1:
                    inputState = isValidInput ? true : msg1;
                    break;
                case -2:
                    inputState = isValidInput ? true : msg2;
                    break;
                case -3:
                    inputState = isValidInput ? true : msg3;
                    break;
            }
        } else {
            isValidInput = true;
            inputState   = true;
        }
        commit('loadIsValidBeneficiaryName', inputState);
    },

    validateNickname({ commit, dispatch },  value) {
        let nickname     = value != undefined ? value : "";
        let isValidInput = true;
        let inputState   = "";

        dispatch('checkPreventOnlySpecial', nickname);
        let chkSpcResult = this.state.beneficiary.isValidCheckOnlySpecial;
        if(chkSpcResult < -1) {
            isValidInput = false;
            switch(chkSpcResult) {
                case -2:
                    inputState = isValidInput ? true : i18n.t('beneficiary-nickname-error2');
                    break;
                case -3:
                    inputState = isValidInput ? true : i18n.t('beneficiary-nickname-error3');
                    break;
            }
        } else {
            isValidInput = true;
            inputState   = true;
        }
        commit('loadIsValidNickname', inputState);
    },

    validateIdentificationType({ commit }, params) {
        let beneIdType   = params.idType != undefined ? params.idType.trim() : params.idType;
        let isValidInput = true;
        let inputState   = "";
        let msg          = "";

        // If not 167 - PHILIPPINES, then mandatory
        if(params.countryId != 167) {
            isValidInput = beneIdType != undefined && beneIdType.length > 0;
            msg          = i18n.t('beneficiary-beneficiary-id-type-help');
        }

        if(beneIdType != undefined && beneIdType.length > 0) {
            isValidInput = check.validPattern("alphaNumericSpaces", beneIdType);
            msg          = i18n.t('beneficiary-beneficiary-id-type-help');
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidIdType', inputState);
    },

    validateIdTypeSelect({ commit }, value) {
        let idTypeId   = value;
        let inputState = (idTypeId > 0) ? true : i18n.t('beneficiary-beneficiary-id-type-select-help');
        commit('loadIsValidIdTypeSelect', inputState);
    },

    validateIdentificationNo({ commit }, params) {
        let beneIdNo     = params.idNo != undefined ? params.idNo.trim() : params.idNo;
        let isValidInput = true;
        let inputState   = "";
        let msg          = "";

        // If not 167 - PHILIPPINES, then mandatory
        if(params.countryId != 167) {
            isValidInput = beneIdNo != undefined && beneIdNo.length > 0;
            msg          = i18n.t('beneficiary-beneficiary-id-no-help');
        }

        if(beneIdNo != undefined && beneIdNo.length > 0) {
            isValidInput = check.validPattern("alphaNumericSpaces", beneIdNo);
            msg          = i18n.t('beneficiary-beneficiary-id-no-help');
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidIdNo', inputState);
    },

    validateBeneficiaryType({ commit }, value) {
        let beneTypeId = value;
        let inputState = (beneTypeId > 0) ? true : i18n.t('beneficiary-beneficiary-type-error');
        commit('loadIsValidBeneficiaryType', inputState);
    },

    validateBank({ commit }, params) {
        let bankId     = params.bankId;
        let inputState = "";
        let msg        = "";
        let isWallet   = (params.txTypeId == 102 || (params.dmId == 1 && params.bankTypeId == 2)) ? true : false

        // 102 - WALLET
        if(isWallet) {
            msg = i18n.t('beneficiary-wallet-name-error');
        } else{
            msg = i18n.t('beneficiary-bank-error');
        }

        inputState = (bankId > 0) ? true : msg;
        commit('loadIsValidBank', inputState);
    },

    validateBankBranch({ commit }, value) {
        let bankBranchId = value;
        let inputState   = (bankBranchId > 0) ? true : i18n.t('beneficiary-bank-branch-error');
        commit('loadIsValidBankBranch', inputState);
    },

    validateBsbCode({ commit }, params) {
        let bsbCode      = params.bsbCode != undefined ? params.bsbCode.trim() : params.bsbCode;
        let isValidInput = true;
        let inputState   = "";
        let msg          = "";

        isValidInput = bsbCode != undefined && bsbCode.length == 6;
        msg          = params.countryId == 152 ? i18n.t('beneficiary-bank-code-help') : i18n.t('beneficiary-bsb-code-help'); // NZ = Bank code

        if(isValidInput) {
            isValidInput = check.validPattern("number", bsbCode);
            msg          = params.countryId == 152 ? i18n.t('beneficiary-bank-code-error') : i18n.t('beneficiary-bsb-code-error'); // NZ = Bank code
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidBsbcode', inputState);
    },

    validateIban({ commit }, value) {
        let iban         = value != undefined ? value.trim() : value;
        let isValidInput = true;
        let inputState   = "";
        let msg          = "";

        isValidInput = iban != undefined && iban.length > 0;
        msg          = i18n.t('beneficiary-iban-help');

        if(isValidInput) {
            isValidInput = check.validPattern("alphanumeric", iban);
            msg          = i18n.t('beneficiary-iban-error');
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidIban', inputState);
    },

    validateSwiftCode({ commit }, value) {
        let swiftCode  = value != undefined ? value.trim() : value;
        let isValidInput = (swiftCode.length >= 8 && swiftCode.length <= 11) && check.validPattern("alphanumeric", swiftCode);
        //let inputState = (swiftCode != undefined && swiftCode.length > 0) ? true : i18n.t('beneficiary-swift-code-help');
        let inputState   = isValidInput ? true : i18n.t('beneficiary-swift-code-help');
        commit('loadIsValidSwiftcode', inputState);
    },

    async validateIfscCode({ dispatch, commit, state }, value) {
        let ifscCode   = value != undefined ? value.trim() : value;
        let inputState = (ifscCode != undefined && ifscCode.length > 0 && ifscCode.length == 11) ? true : i18n.t('beneficiary-ifsc-code-help');
        commit('loadIsValidIfsccode', inputState);
        if (ifscCode.length == 11 && state.bankId > 0) {
            Vue.showPreloader();
            const countryId   = state.homeCountryId
            const bankId      = state.bankId
            const ifscPromise = await this.$api.beneficiary.searchIFSC(countryId, bankId, ifscCode);
            const bankBranch  = ifscPromise;
            // console.log(bankBranch.name)
            if (bankBranch.name.startsWith('00000000000')) {
                // Default branch
                commit('loadIsDisplayIfscBankBranch', true);
            } else {
                // Branch found
                commit('loadIsDisplayIfscBankBranch', false);
            }
            dispatch('setShowFormInputIfscBankBranch', state.isDisplayIfscBankBranch)
            Vue.hidePreloader();
        }
    },

    validateIfscBankBranch({ commit, state }, value) {
        let ifscBankBranch  = value != undefined ? value.trim() : value;
        let inputState = (ifscBankBranch != undefined && ifscBankBranch.length > 0 && state.isDisplayIfscBankBranch) ? true : i18n.t('beneficiary-ifsc-bank-branch-help');
        commit('loadIsValidIfscBankBranch', inputState);
    },

    validateSortCode({ commit }, value) {
        let sortCode     = value != undefined ? value.trim() : value;
        let isValidInput = true;
        let inputState   = "";
        let msg          = "";

        isValidInput = sortCode != undefined && sortCode.length == 6;
        msg          = i18n.t('beneficiary-sort-code-help');

        if(isValidInput) {
            isValidInput = check.validPattern("number", sortCode);
            msg          = i18n.t('beneficiary-sort-code-error');
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidSortcode', inputState);
    },

    validateCollectionAgent({ commit }, value) {
        let colAgentId = value;
        let inputState = (colAgentId > 0) ? true : i18n.t('beneficiary-collection-agent-error');
        commit('loadIsValidCollectionAgent', inputState);
    },

    validateCollectionPoint({ commit }, value) {
        let colPointId = value;
        let inputState = (colPointId > 0) ? true : i18n.t('beneficiary-collection-point-error');
        commit('loadIsValidCollectionPoint', inputState);
    },

    validateProvince({ commit }, value) {
        let provinceId = value;
        let inputState = (provinceId > 0) ? true : i18n.t('beneficiary-province-help');
        commit('loadIsValidProvince', inputState);
    },

    validateCity({ commit, state }, value) {
        //console.log("homeCountryId: "+state.homeCountryId+" ## "+value);
        //console.log("city list: ", state.cityList)

        let cityId     = value;

        if(state.homeCountryId == 152){
            if(isNaN(parseInt(value))){
                state.cityList.map((item) => {
                    if(item.value.toString().toLowerCase() == value.toString().toLowerCase()) {
                        cityId = item.key;
                    }
                });
            }
        }
        //console.log("cityId: "+cityId)
        let inputState = (cityId > 0) ? true : (state.homeCountryId == 106 ? i18n.t('beneficiary-district-help') : i18n.t('beneficiary-city-help'));
        commit('loadIsValidCity', inputState);
    },

    validateStreet({ commit, state }, value) {
        let street     = value != undefined ? value.trim() : value;
        let inputState = (street != undefined && street.length > 0) ? true : (state.homeCountryId == 106 ? i18n.t('beneficiary-street-jp-help') : i18n.t('beneficiary-street-help'));
        commit('loadIsValidStreet', inputState);
    },

    validateLandmark({ commit, state }, value) {
        let landmark     = value != undefined ? value.trim() : value;
        let inputState = (landmark != undefined && landmark.length > 0) ? true : (state.homeCountryId == 106 ? i18n.t('beneficiary-landmark-jp-help') : i18n.t('beneficiary-landmark-help'));
        commit('loadIsValidLandmark', inputState);
    },

    async validatePostcode({ commit, state, dispatch }, params) {
        let postcode       = state.postcode.trim();//params.postcode != undefined ? params.postcode.trim() : params.postcode;
        let isValidInput   = true;
        let inputState     = "";
        let msg            = "";
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false
        let provinceId     = 0;
        let cityId         = 0;
        let cityName       = "";
        let isNotFound     = false;
        let isMultipleCity = false;

        if(postcode != undefined && postcode.length > 0) {
            isValidInput = check.validPattern("number", postcode);
            msg          = i18n.t('beneficiary-postcode-numerical-format');
        }

        // BANK TRANSFER && 106 - JAPAN
        if(isBankTransfer && params.countryId == 106) {
            isValidInput = (postcode.length >= 5 && postcode.length <= 7) && check.validPattern("number", postcode);
            msg          = i18n.t('beneficiary-postcode-jp-help');
        }

        // BANK TRANSFER && (13 - AUSTRALIA || 152 - NEW ZEALAND)
        if(isBankTransfer && (params.countryId == 13 || params.countryId == 152)) {
            isValidInput = postcode.length > 0 && check.validPattern("number", postcode);
            msg          = i18n.t('beneficiary-postcode-help');

            if(!isValidInput){
                if (state.provinceId > 0) {
                    Vue.showPreloader()
                    await dispatch('loadCityList', state.provinceId);
                    Vue.hidePreloader()
                }
            }
        }
        //console.log("msg : "+msg)

        // 13 - AUSTRALIA || 152 - NEW ZEALAND
        if(params.countryId == 13 || params.countryId == 152) {
            if( postcode.length > 3){ // MIN 4 DIGITS, since AU & NZ postcode length = 4
                Vue.showPreloader();
                const cityPromise = await this.$api.beneficiary.getCityByPostcode(postcode, params.countryId);
                const cList       = cityPromise;

                if(cList.length > 0){
                    isValidInput = true
                }

                isValidInput = cList.length > 1  && params.provinceId > 0
                msg          = params.countryId == 152 ?  i18n.t('beneficiary-postcode-info2') : i18n.t('beneficiary-postcode-info')

                if(params.countryId == 13) {
                    if(cList.length > 1) {
                        // console.log("LIST MULTIPLE")
                        if(params.provinceId > 0) {
                            let filterProvinceId = cList.filter(city => city.provinceId == params.provinceId);
                            if(filterProvinceId.length > 0) {
                                let cityDetails = filterProvinceId.filter(cd => cd.id == params.cityId);
                                if(cityDetails.length > 0) {
                                    provinceId = cityDetails[0].provinceId
                                } else {
                                    provinceId = params.provinceId
                                }
                            }
                        } else {
                            provinceId = cList[0].provinceId
                        }

                        cityId = 0;

                        let newCityList = [];
                        let obj = {};

                        for(var j = 0; j < cList.length; j++){
                            obj = {
                                key : cList[j].id,
                                value : cList[j].name
                            }
                            newCityList.push(obj);
                        }
                        isValidInput = false
                        msg          = i18n.t('beneficiary-postcode-info')
                        dispatch('setCityList', newCityList);
                        dispatch('setAllCityList', newCityList);
                        dispatch('setForceRerenderKey', 'suburb');
                    } else if(cList.length == 1) {
                        // console.log("LIST = 1")
                        provinceId = cList[0].provinceId
                        cityId = cList[0].id;
                        cityName = cList[0].name;

                        let newCityList = [];
                        let obj = {};

                        for(var k = 0; k < cList.length; k++){
                            obj = {
                                key : cList[k].id,
                                value : cList[k].name
                            }
                            newCityList.push(obj);
                        }

                        isValidInput = true
                        msg          = ""
                        await dispatch('setCity', {id: cityId, name: cityName});
                        await dispatch('setCityList', newCityList);
                    }else{
                        isValidInput = false
                        msg          = i18n.t('beneficiary-postcode-not-found');
                        // console.log("LIST EMPTY")
                    }
                } else if(params.countryId == 152) {
                    //console.log("postcode val: "+postcode+" ## "+params.cityId+" ## "+state.cityId+" ## "+state.city)
                    provinceId = params.provinceId
                    //console.log("cList: ", cList)
                    if(cList.length > 1) {
                        isMultipleCity = true;
                        if(params.cityId > 0) {
                            let cityDetails = cList.filter(cd => cd.id == params.cityId);
                            //console.log("cityDetails: ", cityDetails);
                            //console.log("cityDetails length: "+cityDetails.length)
                            if(cityDetails.length > 0){
                                cityId = cityDetails[0].id
                                cityName = cityDetails[0].name
                                isValidInput = true
                                await dispatch('setCity', {id: cityId, name: cityName});
                            }else{
                                cityId = 0;
                                isValidInput = false
                            }
                        } else {
                            cityId = 0;
                            isValidInput = false
                        }

                        let newCityList = [];
                        let obj = {};

                        for(var m = 0; m < cList.length; m++){
                            obj = {
                                key : cList[m].id,
                                value : cList[m].name
                            }
                            newCityList.push(obj);
                        }

                        msg          = i18n.t('beneficiary-postcode-info')
                        await dispatch('setCityList', newCityList);
                        await dispatch('setForceRerenderKey', 'suburb');
                    } else if(cList.length == 1) {
                        cityId = cList[0].id
                        cityName = cList[0].name;

                        let newCityList = [];
                        let obj = {};

                        for(var l = 0; l < cList.length; l++){
                            obj = {
                                key : cList[l].id,
                                value : cList[l].name
                            }
                            newCityList.push(obj);
                        }

                        isValidInput = true
                        msg          = ""
                        await dispatch('setCity', {id: cityId, name: cityName});
                        await dispatch('setCityList', newCityList);
                    }else{
                        isValidInput = false
                        msg          = i18n.t('beneficiary-postcode-not-found-2');
                        isNotFound   = true

                        await dispatch('loadCityList', state.provinceId);

                        // console.log("LIST EMPTY")
                    }
                }
                Vue.hidePreloader();
            }
        }

        inputState = isValidInput ? true : msg;
        const result = {
            inputState : inputState,
            provinceId : provinceId,
            cityId     : cityId,
            city       : cityName
        }
        commit('loadIsValidPostcode', result);

        // ===========================
        Vue.showPreloader();
        //setTimeout(() => {
            if(state.isValidPostcode != undefined) {
                let isChanged = inputState == true
                                ? true
                                : (inputState == (state.countryId == 152 ?  i18n.t('beneficiary-postcode-info2') : i18n.t('beneficiary-postcode-info')) ? true : false)
                if(isChanged) {
                    let newProvinceId = state.isValidPostcode.provinceId
                    let newCityId     = state.isValidPostcode.cityId
                    if(state.homeCountryId == 13 /* && state.provinceId != newProvinceId */) {
                        await dispatch('changeProvince', newProvinceId);
                    } else if(state.homeCountryId == 152) {
                        if(state.cityId != newCityId){
                            await dispatch('changeCity', newCityId);
                        }
                        //console.log("after change City: "+state.homeCountryId+" ## "+state.provinceId)
                        //console.log("msg 2: "+inputState+" ## "+isNotFound+" ## "+postcode)
                        //console.log(!isMultipleCity+" ## "+isNotFound+" ## "+postcode)
                        // RESET CITY LIST
                        if(!isMultipleCity || isNotFound || postcode == ""){
                            await dispatch('loadCityList', state.provinceId);
                        }
                    }
                }
                isValidInput = state.isValidPostcode.inputState
                Vue.setInputState(params.postcodeField, isValidInput);
            }
        //}, 2000)
        Vue.hidePreloader();
        // ===========================
    },

    validateAccountNo({ commit }, params) {
        let accountNo      = params.accountNo;
        let isValidInput   = true;
        let inputState     = "";
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false
        let isCashCard     = (params.txTypeId == 5 || params.txTypeId == 103 || params.dmId == 6) ? true : false
        let isBillPayment  = (params.txTypeId == 4 || params.dmId == 0) ? true : false
        let isUpi          = (params.txTypeId == 6 || params.dmId == 9) ? true : false
        let isWallet       = (params.txTypeId == 102 || (params.dmId == 1 && params.bankTypeId == 2)) ? true : false

        let helpMsg  = i18n.t('beneficiary-bank-account-no-help');
        let errorMsg = i18n.t('beneficiary-bank-account-no-error');

        // BKASH && 18 - BANGLADESH
        if(isCashCard && params.countryId == 18) {
            helpMsg  = i18n.t('beneficiary-bkash-no-help');
            errorMsg = i18n.t('beneficiary-bkash-no-error');
        }
        // CASH CARD && 167 - PHILIPPINES
        else if(isCashCard && params.countryId == 167) {
            helpMsg  = i18n.t('beneficiary-cash-card-no-help');
            errorMsg = i18n.t('beneficiary-cash-card-no-error');
        }
        // BILL PAYMENT
        else if(isBillPayment) {
            helpMsg  = i18n.t('beneficiary-bill-account-no-help');
            errorMsg = i18n.t('beneficiary-bill-account-no-error');
        }
        // UPI
        else if(isUpi) {
            helpMsg  = i18n.t('beneficiary-virtual-payment-address-help');
            errorMsg = i18n.t('beneficiary-virtual-payment-address-help');
        }
        // Wallet
        else if(isWallet) {
            helpMsg  = i18n.t('beneficiary-mobile-topup-no-help');
            errorMsg = i18n.t('beneficiary-mobile-topup-no-error');
        }

        isValidInput = accountNo.length > 0;
        inputState   = isValidInput ? true : helpMsg

        if(isValidInput) {
            // If not Vietnam and European Union (EU), then allow only numeric account number
            // Skip this validation for UPI
            if((params.countryId != 228 && params.countryId != 238) && !isUpi) {
                isValidInput = check.validPattern("number", accountNo);
                inputState   = isValidInput ? true : errorMsg
                if(isWallet){
                    commit('loadIsValidWalletNo', inputState);
                }else{
                    commit('loadIsValidAccountNo', inputState);
                }
            }
            // Vietnam and European Union (EU), allow alpha numeric account number
            // Skip this validation for UPI
            else if((params.countryId == 228 || params.countryId == 238) && !isUpi) {
                isValidInput = check.validPattern("alphanumeric", accountNo);
                inputState   = isValidInput ? true : helpMsg;
                commit('loadIsValidAccountNo', inputState);
            }

            // BANK TRANSFER && 221 - UNITED KINGDOM
            if(isBankTransfer && params.countryId == 221) {
                isValidInput = accountNo.length == 8;
                inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error2');
            }

            // 99 - INDONESIA
            if(params.countryId == 99) {
                // 77 - BRI
                if(params.bankId == 77 || params.bankId == 1918) {
                    isValidInput = accountNo.length == 15;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                }
                // 67 - MANDIRI
                if(params.bankId == 67 || params.bankId == 1919 || params.bankId == 2010) {
                    isValidInput = accountNo.length == 13;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                }

                // Wallet
                if(isWallet) {
                    let isValidInputPattern = check.validPattern("number", accountNo);
                    inputState   = isValidInputPattern ? true : errorMsg
                    isValidInput = isValidInputPattern ? true : false

                    if(isValidInputPattern){
                        isValidInput = !(/* accountNo.substring(0, 2) != 62 || */ accountNo.length < 9 || accountNo.length > 12);
                        inputState   = isValidInput ? true : i18n.t('beneficiary-mobile-topup-no-error2');
                    }
                }
            }

            // BANK TRANSFER && 18 - BANGLADESH
            if(isBankTransfer && params.countryId == 18) {
                isValidInput = accountNo.length >= 9;
                inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
            }

            // BANK TRANSFER && 167 - PHILIPPINES
            if(isBankTransfer && params.countryId == 167) {
                if (params.bankId == 1 || params.bankId == 4 || params.bankId == 484 || params.bankId == 30 || params.bankId == 520 || params.bankId == 481 || params.bankId == 3734 || params.bankId == 3735 || params.bankId == 1649 || params.bankId == 24 || params.bankId == 530 || params.bankId == 29 || params.bankId == 522 || params.bankId == 35 || params.bankId == 514) {
                    isValidInput = accountNo.length == 10;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                } else if (params.bankId == 25 || params.bankId == 528) {
                    isValidInput = accountNo.length == 11;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                } else if (params.bankId == 1350 || params.bankId == 3716 || params.bankId == 6 || params.bankId == 487 || params.bankId == 26 || params.bankId == 526 || params.bankId == 2301 || params.bankId == 15 || params.bankId == 504 || params.bankId == 44 || params.bankId == 496 || params.bankId == 1823 || params.bankId == 21 || params.bankId == 532 || params.bankId == 23 || params.bankId == 531 || params.bankId == 40 || params.bankId == 507 || params.bankId == 41 || params.bankId == 500 || params.bankId == 45 || params.bankId == 495 || params.bankId == 1823 || params.bankId == 12 || params.bankId == 513 || params.bankId == 3717) {
                    isValidInput = accountNo.length == 12;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                } else if (params.bankId == 48 || params.bankId == 47 || params.bankId == 491 || params.bankId == 489) {
                    isValidInput = accountNo.length == 13;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                } else if (params.bankId == 31 || params.bankId == 518) {
                    isValidInput = accountNo.length == 10 || accountNo.length == 11;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                } else if (params.bankId == 14 || params.bankId == 503) {
                    isValidInput = accountNo.length == 10 || accountNo.length == 12 || accountNo.length == 13;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                } else if (params.bankId == 5 || params.bankId == 485 || params.bankId == 9 || params.bankId == 494 || params.bankId == 2032 || params.bankId == 17 || params.bankId == 521 || params.bankId == 22 || params.bankId == 533 || params.bankId == 18 || params.bankId == 2112 || params.bankId == 482 || params.bankId == 2 || params.bankId == 524) {
                    isValidInput = accountNo.length == 10 || accountNo.length == 12;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                } else if (params.bankId == 8 || params.bankId == 492 || params.bankId == 16 || params.bankId == 519) {
                    isValidInput = accountNo.length == 10 || accountNo.length == 13;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                } else if (params.bankId == 7 || params.bankId == 490 || params.bankId == 32 || params.bankId == 20 || params.bankId == 529 || params.bankId == 517) {
                    isValidInput = accountNo.length == 10 || accountNo.length == 16;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                } else if (params.bankId == 13 || params.bankId == 502) {
                    isValidInput = accountNo.length == 11 || accountNo.length == 12;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                } else if (params.bankId == 36 || params.bankId == 512){
                    isValidInput = accountNo.length == 12 || accountNo.length == 15;
                    inputState   = isValidInput ? true : i18n.t('beneficiary-bank-account-no-error4');
                }
            }

            // WALLET && 167 - PHILIPPINES
            if(isWallet && params.countryId == 167) {
                let isValidInputPattern = check.validPattern("number", accountNo);
                inputState   = isValidInputPattern ? true : errorMsg
                isValidInput = isValidInputPattern ? true : false

                if(isValidInputPattern){
                    isValidInput = !(accountNo.length < 4);
                    inputState   = isValidInput ? true : i18n.t('beneficiary-mobile-topup-no-error2');
                }
            }
        }

        if(isWallet){
            commit('loadIsValidWalletNo', inputState);
        }else{
            commit('loadIsValidAccountNo', inputState);
        }
    },

    validateDOB({ commit }, value) {
        let dob          = value;
        let isValidInput = true;
        let inputState   = "";
        let msg          = "";
        let dateRegexp   = new RegExp("^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/\\d{4}$");

        if(dob.length == 0) {
            isValidInput = false;
            msg          = i18n.t('beneficiary-beneficiary-dob-help');
        } else {
            if(!dateRegexp.test(dob)) {
                isValidInput = false;
                msg          = i18n.t('beneficiary-beneficiary-dob-error');
            } else {
                let split = dob.split("/");
                let day   = split[0];
                let month = split[1];
                let year  = split[2];

                if((month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
                    isValidInput = false;
                    msg          = i18n.t('beneficiary-beneficiary-dob-error');
                }

                if(month == 2) {
                    var leap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0));
                    if (day > 29 || (day == 29 && !leap)) {
                    isValidInput = false;
                    msg          = i18n.t('beneficiary-beneficiary-dob-error');
                    }
                }
            }
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidDateOfBirth', inputState);
    },

    validatePhilGovMemberType({ commit }, value) {
        let memberTypeId = value;
        let inputState   = (memberTypeId > 0) ? true : i18n.t('beneficiary-member-type-error');
        commit('loadIsValidPhilGovMemberType', inputState);
    },

    validateRefNote({ commit, dispatch }, params) {
        let refNo         = params.refNo != undefined ? params.refNo : "";
        let isValidInput  = true;
        let inputState    = "";
        let isCollection  = (params.txTypeId == 3 || params.dmId == 3) ? true : false
        let isBillPayment = (params.txTypeId == 4 || params.dmId == 0) ? true : false

        dispatch('checkPreventOnlySpecial', refNo);
        let chkSpcResult = this.state.beneficiary.isValidCheckOnlySpecial;
        if(chkSpcResult < -1) {
            isValidInput = false;
            switch(chkSpcResult) {
                case -2:
                    inputState = isValidInput ? true : i18n.t('beneficiary-ref-no-error2');
                    break;
                case -3:
                    inputState = isValidInput ? true : i18n.t('beneficiary-ref-no-error3');
                    break;
            }
        } else {
            // (COLLECTION && 95 - HONG KONG S.A.R.) || (BILL PAYMENT && 167 - PHILIPPINES)
            if((isCollection && params.countryId == 95) || (isBillPayment && params.countryId == 167)) {
                isValidInput = refNo.length > 0;
                inputState   = isValidInput ? true : i18n.t('beneficiary-ref-no-error');
            } else {
                isValidInput = true;
                inputState   = true;
            }
        }
        commit('loadIsValidRefNo', inputState);
    },

    validateAbn({ commit }, value) {
        let abn          = value != undefined ? value.trim() : value;
        let isValidInput = true;
        let inputState   = "";
        let msg          = i18n.t('beneficiary-abn-error');

        isValidInput = abn != undefined && abn.length == 11;

        if(isValidInput) {
            isValidInput = check.validPattern("number", abn);
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidAbn', inputState);
    },

    validateAcn({ commit }, value) {
        let acn          = value != undefined ? value.trim() : value;
        let isValidInput = true;
        let inputState   = "";
        let msg          = i18n.t('beneficiary-acn-error');

        if(acn != undefined && acn.length > 0) {
            isValidInput = acn.length == 9;

            if(isValidInput) {
                isValidInput = check.validPattern("number", acn);
            }
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidAcn', inputState);
    },

    validateNzbn({ commit }, value) {
        let nzbn         = value != undefined ? value.trim() : value;
        let isValidInput = true;
        let inputState   = "";
        let msg          = i18n.t('beneficiary-nzbn-error');

        isValidInput = nzbn != undefined && nzbn.length == 13;

        if(isValidInput) {
            isValidInput = check.validPattern("number", nzbn);
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidNzbn', inputState);
    },

    validatePaymentPurpose({ commit, dispatch }, params) {
        let ppId       = params.ppId;
        let inputState = "";

        inputState = (ppId > 0 || ppId == -1) ? true : params.countryId == 98 ? i18n.t('beneficiary-payment-purpose-error4') :  i18n.t('beneficiary-payment-purpose-error');

        if(ppId == -1) {
            dispatch('validateOtherPaymentPurpose', params.ppOther);
            inputState = this.state.beneficiary.isValidPaymentPurpose;
        }
        commit('loadIsValidPaymentPurpose', inputState);
    },

    validateOtherPaymentPurpose({ commit, dispatch }, value) {
        let ppOther      = value != undefined ? value : '';
        let isValidInput = true;
        let inputState   = "";

        dispatch('checkPreventOnlySpecial', ppOther);
        let chkSpcResult = this.state.beneficiary.isValidCheckOnlySpecial;
        if(chkSpcResult < 0) {
            isValidInput = false;
            switch(chkSpcResult) {
                case -1:
                    inputState = isValidInput ? true : i18n.t('beneficiary-payment-purpose-error');
                    break;
                case -2:
                    inputState = isValidInput ? true : i18n.t('beneficiary-payment-purpose-error2');
                    break;
                case -3:
                    inputState = isValidInput ? true : i18n.t('beneficiary-payment-purpose-error3');
                    break;
            }
        } else {
            isValidInput = true;
            inputState   = true;
        }
        commit('loadIsValidPaymentPurpose', inputState);
    },

    validateHomeNo({ commit }, params) {
        let homeNoTemp   = params.homeNo != undefined ? params.homeNo.trim() : params.homeNo;
        let isValidInput = true;
        let inputState   = "";
        let homeIDD      = params.homeIDD;

        if(homeNoTemp.length == 0) {
            isValidInput = true;
            inputState   = true;
        } else if(homeNoTemp.length > 0) {
            isValidInput = homeIDD > 0;
            inputState   = isValidInput ? true : i18n.t('beneficiary-phone-code-error');

            isValidInput = parseInt(homeNoTemp) !== 0;
            inputState   = isValidInput ? true : i18n.t('beneficiary-home-no-error');

            let firstDigitHome = homeNoTemp.substring(0, 1);
            if(firstDigitHome == 0 && params.countryId == 99) {
                //homeNoTemp   = homeNoTemp.substring(0, 1);
                isValidInput = true;
            }

            if(homeNoTemp.length !== 1 && parseInt(homeNoTemp) !== 0){
                isValidInput = check.validPattern("number", homeNoTemp);
            }else{
                isValidInput = false
            }
            inputState   = isValidInput ? true : i18n.t('beneficiary-home-no-error2');
        }
        commit('loadIsValidHomeNo', inputState);
    },

    validateMobileNo({ commit }, params) {
        let mobileNoTemp   = params.mobileNo != undefined ? params.mobileNo.trim() : params.mobileNo;
        let isValidInput   = true;
        let inputState     = "";
        let mobileIDD      = params.mobileIDD;
        let isBankTransfer = (params.txTypeId == 1 || params.dmId == 1) ? true : false
        let isDoorToDoor   = (params.txTypeId == 2 || params.dmId == 4) ? true : false
        let isCollection   = (params.txTypeId == 3 || params.dmId == 3) ? true : false

        if(mobileNoTemp.length == 0) {
            isValidInput = true;
            inputState   = true;
        } else if(mobileNoTemp.length > 0) {
            isValidInput = mobileIDD > 0;
            inputState   = isValidInput ? true : i18n.t('beneficiary-phone-code-error');

            isValidInput = parseInt(mobileNoTemp) !== 0;
            inputState   = isValidInput ? true : i18n.t('beneficiary-mobile-no-error');

            let firstDigitMobile = mobileNoTemp.substring(0, 1);
            if(firstDigitMobile == 0 && params.countryId == 99) {
                //mobileNoTemp = mobileNoTemp.substring(0, 1);
                isValidInput = true;
            }

            if(mobileNoTemp.length !== 1 && parseInt(mobileNoTemp) !== 0){
                isValidInput = check.validPattern("number", mobileNoTemp);
            }else{
                isValidInput = false
            }
            inputState   = isValidInput ? true : i18n.t('beneficiary-mobile-no-error3');
        }

        // (BANK TRANSFER && (13 - AUSTRALIA || 111 - S.KOREA || 228 - VIETNAM)) || DOOR TO DOOR || COLLECTION
        if(
            (isBankTransfer && (params.countryId == 13 || params.countryId == 111 || params.countryId == 228))
            || isDoorToDoor || isCollection
        ) {
            //console.log("mobileNoTemp: "+mobileNoTemp+" ## "+check.validPattern("number", mobileNoTemp))
            isValidInput = mobileNoTemp.length > 1 && parseInt(mobileNoTemp) !== 0 && check.validPattern("number", mobileNoTemp);
            inputState   = isValidInput ? true : (parseInt(mobileNoTemp) !== 0 ? (!check.validPattern("number", mobileNoTemp) ? i18n.t('beneficiary-mobile-no-error') : i18n.t('beneficiary-mobile-no-error2')) : i18n.t('beneficiary-mobile-no-error'));
        }
        commit('loadIsValidMobileNo', inputState);
    },

    validateEmail({ commit }, params) {
        let email        = params.email != undefined ? params.email.trim() : params.email;
        let isValidInput = true;
        let inputState   = "";
        let msg          = "";
        let isPhilGov    = (params.txTypeId == 101 || (params.dmId == 1 && params.bankTypeId == 1)) ? true : false

        if(email.length > 0) {
            isValidInput = check.validPattern("email", email);
            msg = i18n.t('beneficiary-email-error');
        }

        // 101 - PHIL GOV SERVICE && 167 - PHILIPPINES && 4520 - PhilHealth
        if(isPhilGov && params.countryId == 167 && params.bankId == 4520) {
            isValidInput = email.length > 0 && check.validPattern("email", email);
            msg = i18n.t('beneficiary-email-help');
        }

        inputState = isValidInput ? true : msg;
        commit('loadIsValidEmail', inputState);
    },

    checkPreventOnlySpecial({ commit }, value) {
        let specialList  = ['.', ',', '!', '!', '{ ', '}', '<', '>', '?', ':', ';', '\u2013', '\u2014', '-', '(', ')', '[', ']', '\'', '"', '\u2018', '\u0060', '\u2019', '\u201C', '\u201D', '^', '@', '~', '`', '$', '%', '*', '_', '|', '/', '&'];
        let val          = value;
        let removedWhite = val.replace(/\s+/g,'');
        let len          = val.length, removedLen = removedWhite.length;
        let i            = 0, spcCount = 0, checkChar = 0;
        if(len == 0) { // must not be empty!
            commit('loadCheckPreventOnlySpecial', -1);
        } else if(removedLen == 0) { // considered error, because the value contains only white spaces.
            commit('loadCheckPreventOnlySpecial', -2);
        } else {
            spcCount = 0;
            for(i = 0; i < removedLen; i++) {
                checkChar = removedWhite.charAt(i);
                if(specialList.indexOf(checkChar)>-1) { // if in list of Special Character, add to count.
                    spcCount++;
                }
            }
            if(spcCount == removedLen) { // considered error, because the value contains only special characters.
                commit('loadCheckPreventOnlySpecial', -3);
            } else {
                commit('loadCheckPreventOnlySpecial', 0);
            }
        }
    },

    async loadPhilGovMemberTypeList({ dispatch }) {
        const self = this;

        self.philGovMemberTypeList = []
        const memberTypePromise    = await this.$api.beneficiary.getPhilGovMemberTypeList();
        dispatch('setPhilGovMemberTypeList', memberTypePromise);
        dispatch('changePhilGovMemberType',1);
    },

    changePhilGovMemberType({ state, dispatch }, memTypeId) {
        const mtList = state.philGovMemberTypeList;

        Object.keys(mtList).forEach(key => {
            if(mtList[key].id == memTypeId) {
                dispatch('setPhilGovMemberType', {id: memTypeId, name: mtList[key].name});
                return;
            }
        })
    },
    /* SHOW/HIDE INPUT*/
    showHideInput({ dispatch, state }) {
        // dispatch('resetFormData'); //this.resetFormData();

        // 6 - UPI
        if(state.transactionTypeId == 6) {
            state.bankId   = 5000;
            state.bankName = "UPI";
        }
        // 101 - PHIL GOV SERVICE
        else if(state.transactionTypeId == 101) {
            state.bankId         = 4522;
            state.bankName       = "SSS";
            state.paymentPurpose = "Phil Gov Services";

            dispatch('loadPhilGovMemberTypeList');
        }
        // 103 - BKASH && 18 - BANGLADESH
        else if(state.transactionTypeId == 103 && state.homeCountryId == 18) {
            state.bankId    = 4255;
            state.bankName  = "BANGLADESH BKASH";
            state.isbKashTx = true;
        }

        const params = {
            countryId : state.homeCountryId,
            txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
            dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
            bankId    : state.bankId,
            bankTypeId: 0,
            caId      : state.collectionAgentId,
            provinceId: state.provinceId,
            cityId    : state.cityId,
            beneTypeId: state.beneficiaryTypeId,
            ppId      : state.paymentPurposeId,
            ifscCode  : state.ifscCode
        }

        let beneficiaryState = state

        dispatch('displayBillPayment', params);
        state.showFormSet.billPayment = beneficiaryState.isDisplayBillPayment

        dispatch('displayBankTransfer', params);
        state.showFormSet.bankTransfer = beneficiaryState.isDisplayBankTransfer

        dispatch('displayCollection', params);
        state.showFormSet.collection = beneficiaryState.isDisplayCollection

        dispatch('displayProvinceDetails', params);
        state.showFormSet.provinceDetails = beneficiaryState.isDisplayProvinceDetails

        dispatch('displayDoorToDoor', params);
        state.showFormSet.doorToDoor = beneficiaryState.isDisplayDoorToDoor

        dispatch('displayKaasiDetails', params);
        state.showFormSet.kaasiDetails = beneficiaryState.isDisplayKaasiDetails

        dispatch('displayBillerCode', params);
        state.showFormInput.billPayment.billerCode = beneficiaryState.isDisplayBillerCode

        dispatch('displayBank', params);
        state.showFormInput.bankTransfer.bankName = beneficiaryState.isDisplayBank.isDisplay
        state.bankNameLabel = beneficiaryState.isDisplayBank.label
        state.bankNamePlaceholder = beneficiaryState.isDisplayBank.placeholder

        dispatch('displayBankBranch', params);
        state.showFormInput.bankTransfer.bankBranch = beneficiaryState.isDisplayBankBranch

        dispatch('displayBeneficiaryType', params);
        state.showFormInput.bankTransfer.beneficiaryType = beneficiaryState.isDisplayBeneficiaryType

        dispatch('displayBsbCode', params);
        state.showFormInput.bankTransfer.bsbCode = beneficiaryState.isDisplayBsbCode.isDisplay
        state.bsbCodeLabel = beneficiaryState.isDisplayBsbCode.label

        dispatch('displayIban', params);
        state.showFormInput.bankTransfer.iban = beneficiaryState.isDisplayIban

        dispatch('displayIfscCode', params);
        state.showFormInput.bankTransfer.ifscCode = beneficiaryState.isDisplayIfscCode

        // dispatch('displayIfscBankBranch', params);
        // console.log("state.showFormInput.bankTransfer.ifscBankBranch " + beneficiaryState.isDisplayIfscBankBranch)
        state.showFormInput.bankTransfer.ifscBankBranch = beneficiaryState.isDisplayIfscBankBranch

        dispatch('displaySortCode', params);
        state.showFormInput.bankTransfer.sortCode = beneficiaryState.isDisplaySortcode

        dispatch('displaySwiftCode', params)
        state.showFormInput.bankTransfer.swiftCode = beneficiaryState.isDisplaySwiftCode

        dispatch('displayCity', params);
        state.showFormInput.provinceDetails.city = beneficiaryState.isDisplayCity

        dispatch('displayPostcode', params);
        state.showFormInput.provinceDetails.postcode = beneficiaryState.isDisplayPostcode

        dispatch('displayProvince', params);
        state.showFormInput.provinceDetails.province = beneficiaryState.isDisplayProvince

        dispatch('displayBeneficiaryName', params);
        state.showFormInput.root.beneficiaryName = beneficiaryState.isDisplayBeneficiaryName.isDisplay
        state.beneficiaryNameLabel = beneficiaryState.isDisplayBeneficiaryName.label

        dispatch('displayNickname', params);
        state.showFormInput.root.nickname = beneficiaryState.isDisplayNickname

        dispatch('displayIdType', params);
        state.showFormInput.root.identificationType = beneficiaryState.isDisplayIdType.isDisplay
        state.identificationTypeLabel = beneficiaryState.isDisplayIdType.label

        dispatch('displayIdTypeSelect', params);
        state.showFormInput.root.idTypeSelect = beneficiaryState.isDisplayIdTypeSelect

        dispatch('displayIdNo', params);
        state.showFormInput.root.identificationNo = beneficiaryState.isDisplayIdNo.isDisplay
        state.identificationNoLabel = beneficiaryState.isDisplayIdNo.label

        dispatch('displayAccountNo', params);
        let isWallet       = (params.txTypeId == 102 || (params.dmId == 1 && params.bankTypeId == 2)) ? true : false
        if(isWallet){
            state.showFormInput.root.walletNo = true
			state.showFormInput.root.bankAccountNo = false
            state.bankAccountNoLabel = beneficiaryState.isDisplayWalletNo.label
        }else{
            state.showFormInput.root.bankAccountNo = beneficiaryState.isDisplayAccountNo.isDisplay
            state.bankAccountNoLabel = beneficiaryState.isDisplayAccountNo.label
        }

        dispatch('displayCnIdNo', params);
        state.showFormInput.root.cnIdentificationNo = beneficiaryState.isDisplayCnIdNo

        dispatch('displayDateOfBirth', params)
        state.showFormInput.root.dob = beneficiaryState.isDisplayDateOfBirth

        dispatch('displayPhilGovFullName', params);
        state.showFormInput.root.philGovServiceFullname = beneficiaryState.isDisplayPhilGovFullName

        dispatch('displayPhilGovNickname', params);
        state.showFormInput.root.philGovServiceNickname = beneficiaryState.isDisplayPhilGovNickname

        dispatch('displayPhilGovMemberType', params);
        state.showFormInput.root.philGovServiceMemberType = beneficiaryState.isDisplayPhilGovMemberType

        dispatch('displayRefNo', params);
        state.showFormInput.root.refNo = beneficiaryState.isDisplayRefNo.isDisplay
        state.refNoLabel = beneficiaryState.isDisplayRefNo.label

        dispatch('displayAudBtState', params);
        state.showFormInput.kaasiDetails.state = beneficiaryState.isDisplayAudBtState

        dispatch('displayAudRadio', params);
        state.showFormInput.kaasiDetails.radioButton = beneficiaryState.isDisplayAudRadio

        dispatch('displayAudBusiness', params);
        state.showFormInput.kaasiDetails.auBusiness = beneficiaryState.isDisplayAudBusiness

        dispatch('displayNzBusiness', params)
        state.showFormInput.kaasiDetails.nzBusiness = beneficiaryState.isDisplayNzBusiness

        dispatch('displayPaymentPurpose', params);
        state.showFormInput.contact.paymentPurpose = beneficiaryState.isDisplayPaymentPurpose

        dispatch('displayPaymentPurposeOther', params);
        state.showFormInput.contact.paymentPurposeOther = beneficiaryState.isDisplayPaymentPurposeOther

        dispatch('displayHomeNo', params);
        state.showFormInput.contact.homeNo = beneficiaryState.isDisplayHomeNo

        dispatch('displayMobileNo', params);
        state.showFormInput.contact.mobileNo = beneficiaryState.isDisplayMobileNo.isDisplay
        state.mobileNoLabel = beneficiaryState.isDisplayMobileNo.label

        dispatch('displayEmail', params);
        state.showFormInput.contact.email = beneficiaryState.isDisplayEmail.isDisplay
        state.emailLabel = beneficiaryState.isDisplayEmail.label

        dispatch('changeStreetLabel', params);
        state.streetLabel = beneficiaryState.streetLabel

        dispatch('changeCityLabel', params);
        state.cityLabel = beneficiaryState.cityLabel

        dispatch('changeLandmarkLabel', params);
        state.landmarkLabel = beneficiaryState.landmarkLabel

        dispatch('changePostcodeLabel', params);
        state.postcodeLabel = beneficiaryState.postcodeLabel
    },

    showHideInput2({ state, dispatch }) {
        const params = {
            countryId : state.homeCountryId,
            txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
            dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
            bankId    : state.bankId,
            bankTypeId: state.bankTypeId,
            caId      : state.collectionAgentId,
            beneTypeId: state.beneficiaryTypeId,
            ppId      : state.paymentPurposeId
        }

        let beneficiaryState = state

        dispatch('displayBillPayment', params);
        state.showFormSet.billPayment = beneficiaryState.isDisplayBillPayment;

        dispatch('displayBankTransfer', params)
        state.showFormSet.bankTransfer = beneficiaryState.isDisplayBankTransfer;

        dispatch('displayCollection', params);
        state.showFormSet.collection = beneficiaryState.isDisplayCollection;

        dispatch('displayProvinceDetails', params);
        state.showFormSet.provinceDetails = beneficiaryState.isDisplayProvinceDetails

        dispatch('displayDoorToDoor', params)
        state.showFormSet.doorToDoor = beneficiaryState.isDisplayDoorToDoor

        dispatch('displayKaasiDetails', params)
        state.showFormSet.kaasiDetails = beneficiaryState.isDisplayKaasiDetails

        dispatch('displayBillerCode', params)
        state.showFormInput.billPayment.billerCode = beneficiaryState.isDisplayBillerCode

        dispatch('displayBank', params)
        state.showFormInput.bankTransfer.bankName = beneficiaryState.isDisplayBank.isDisplay
        state.bankNameLabel = beneficiaryState.isDisplayBank.label

        dispatch('displayBankBranch', params)
        state.showFormInput.bankTransfer.bankBranch = beneficiaryState.isDisplayBankBranch

        dispatch('displayBeneficiaryType', params)
        state.showFormInput.bankTransfer.beneficiaryType = beneficiaryState.isDisplayBeneficiaryType

        dispatch('displayBsbCode', params)
        state.showFormInput.bankTransfer.bsbCode = beneficiaryState.isDisplayBsbCode.isDisplay
        state.bsbCodeLabel = beneficiaryState.isDisplayBsbCode.label

        dispatch('displayIban', params)
        state.showFormInput.bankTransfer.iban = beneficiaryState.isDisplayIban

        dispatch('displayIfscCode', params)
        state.showFormInput.bankTransfer.ifscCode = beneficiaryState.isDisplayIfscCode

        // dispatch('displayIfscBankBranch', params)
        state.showFormInput.bankTransfer.ifscBankBranch = beneficiaryState.isDisplayIfscBankBranch

        dispatch('displaySortCode', params)
        state.showFormInput.bankTransfer.sortCode = beneficiaryState.isDisplaySortcode

        dispatch('displaySwiftCode', params)
        state.showFormInput.bankTransfer.swiftCode = beneficiaryState.isDisplaySwiftCode

        dispatch('displayCity', params)
        state.showFormInput.provinceDetails.city = beneficiaryState.isDisplayCity

        dispatch('displayPostcode', params)
        state.showFormInput.provinceDetails.postcode = beneficiaryState.isDisplayPostcode

        dispatch('displayProvince', params)
        state.showFormInput.provinceDetails.province = beneficiaryState.isDisplayProvince

        dispatch('displayBeneficiaryName', params)
        state.showFormInput.root.beneficiaryName = beneficiaryState.isDisplayBeneficiaryName.isDisplay
        state.beneficiaryNameLabel = beneficiaryState.isDisplayBeneficiaryName.label

        dispatch('displayNickname', params)
        state.showFormInput.root.nickname = beneficiaryState.isDisplayNickname

        dispatch('displayIdType', params)
        state.showFormInput.root.identificationType = beneficiaryState.isDisplayIdType.isDisplay
        state.identificationTypeLabel = beneficiaryState.isDisplayIdType.label

        dispatch('displayIdTypeSelect', params)
        state.showFormInput.root.idTypeSelect = beneficiaryState.isDisplayIdTypeSelect

        dispatch('displayIdNo', params)
        state.showFormInput.root.identificationNo = beneficiaryState.isDisplayIdNo.isDisplay
        state.identificationNoLabel = beneficiaryState.isDisplayIdNo.label

        dispatch('displayAccountNo', params)
        let isWallet       = (params.txTypeId == 102 || (params.dmId == 1 && params.bankTypeId == 2)) ? true : false
        if(isWallet){
            state.showFormInput.root.walletNo = true
			state.showFormInput.root.bankAccountNo = false
            state.bankAccountNoLabel = beneficiaryState.isDisplayWalletNo.label
        }else{
            state.showFormInput.root.bankAccountNo = beneficiaryState.isDisplayAccountNo.isDisplay
            state.bankAccountNoLabel = beneficiaryState.isDisplayAccountNo.label
        }

        dispatch('displayCnIdNo', params)
        state.showFormInput.root.cnIdentificationNo = beneficiaryState.isDisplayCnIdNo

        dispatch('displayDateOfBirth', params)
        state.showFormInput.root.dob = beneficiaryState.isDisplayDateOfBirth

        dispatch('displayPhilGovFullName', params)
        state.showFormInput.root.philGovServiceFullname = beneficiaryState.isDisplayPhilGovFullName

        dispatch('displayPhilGovNickname', params)
        state.showFormInput.root.philGovServiceNickname = beneficiaryState.isDisplayPhilGovNickname

        dispatch('displayPhilGovMemberType', params)
        state.showFormInput.root.philGovServiceMemberType = beneficiaryState.isDisplayPhilGovMemberType

        dispatch('displayRefNo', params)
        state.showFormInput.root.refNo = beneficiaryState.isDisplayRefNo.isDisplay
        state.refNoLabel = beneficiaryState.isDisplayRefNo.label

        dispatch('displayAudBtState', params);
        state.showFormInput.kaasiDetails.state = beneficiaryState.isDisplayAudBtState

        dispatch('displayAudRadio', params)
        state.showFormInput.kaasiDetails.radioButton = beneficiaryState.isDisplayAudRadio

        dispatch('displayAudBusiness', params)
        state.showFormInput.kaasiDetails.auBusiness = beneficiaryState.isDisplayAudBusiness

        dispatch('displayNzBusiness', params)
        state.showFormInput.kaasiDetails.nzBusiness = beneficiaryState.isDisplayNzBusiness

        dispatch('displayPaymentPurpose', params)
        state.showFormInput.contact.paymentPurpose = beneficiaryState.isDisplayPaymentPurpose

        dispatch('displayPaymentPurposeOther', params)
        state.showFormInput.contact.paymentPurposeOther = beneficiaryState.isDisplayPaymentPurposeOther

        dispatch('displayHomeNo', params)
        state.showFormInput.contact.homeNo = beneficiaryState.isDisplayHomeNo

        dispatch('displayMobileNo', params)
        state.showFormInput.contact.mobileNo = beneficiaryState.isDisplayMobileNo.isDisplay
        state.mobileNoLabel = beneficiaryState.isDisplayMobileNo.label

        dispatch('displayEmail', params)
        state.showFormInput.contact.email = beneficiaryState.isDisplayEmail.isDisplay
        state.emailLabel = beneficiaryState.isDisplayEmail.label

        dispatch('changeStreetLabel', params)
        state.streetLabel = beneficiaryState.streetLabel

        dispatch('changeCityLabel', params)
        state.cityLabel = beneficiaryState.cityLabel

        dispatch('changeLandmarkLabel', params)
        state.landmarkLabel = beneficiaryState.landmarkLabel

        dispatch('changePostcodeLabel', params)
        state.postcodeLabel = beneficiaryState.postcodeLabel

        // PHIL GOV SERVICE
        if(state.deliveryMethodId == 1 && state.bankTypeId == 1) {
            dispatch('loadPhilGovMemberTypeList');
        }
    },
    /* END OF SHOW HIDE INPUT */

    /* RESET FORM DATA */
    resetFormData({ state, commit }) {

        state.isbKashTx           = false;
        state.isDisplayErrorMsg   = false;
        state.radioErrorMsg       = "";

        state.billCorporationId   = 0;
        state.billCorporationName = "";
        state.billerCode          = "";
        state.beneficiaryName     = "";
        state.nickname            = "";
        state.identificationType  = "";
        state.idTypeSelect        = "";
        state.idTypeSelectId      = 0;
        state.identificationNo    = "";
        state.beneficiaryType     = "";
        state.beneficiaryTypeId   = 0;
        state.bankName            = "";
        state.bankId              = 0;
        state.bankBranch          = "";
        state.bankBranchId        = 0;
        state.bsbCode             = "";
        state.iban                = "";
        state.swiftCode           = "";
        state.ifscCode            = "";
        state.ifscBankBranch      = "";
        state.sortCode            = "";
        state.collectionAgent     = "";
        state.collectionAgentId   = 0;
        state.collectionPoint     = "";
        state.collectionPointId   = 0;
        state.province            = "";
        state.provinceId          = 0;
        state.city                = "";
        state.cityId              = 0;
        state.street              = "";
        state.postcode            = "";
        state.locatingNote        = "";
        state.landmark            = "";
        state.bankAccountNo       = "";
        state.walletNo            = "";
        state.dateOfBirth         = "";
        state.philGovMemberType   = "";
        state.philGovMemberTypeId = 1;
        state.refNo               = "";
        state.audAbn              = "";
        state.audAcn              = "";
        state.nzbn                = "";
        // DR-1845 code-inspection fix (Major) - was direct state mutation
        // (state.beneficiaryCountryId = 0; ...), bypassing Vuex's mutation-commit
        // mechanism entirely, unlike every other field on this line which is
        // pre-existing (out of DR-1845 scope) - this one was newly added by
        // DR-1845 and had the mutations it needed (setBeneficiaryCountry/
        // setBeneficiaryTownCity) already sitting right there in this same file.
        commit('setBeneficiaryCountry', { id: 0, name: '' });
        commit('setBeneficiaryTownCity', '');
        state.paymentPurpose      = "";
        state.paymentPurposeId    = 0;
        state.paymentPurposeOther = "";
        state.homeNo              = "";
        state.mobileNo            = "";
        state.email               = "";

        state.showFormSet.billPayment                     = false;
        state.showFormSet.bankTransfer                    = false;
        state.showFormSet.collection                      = false;
        state.showFormSet.provinceDetails                 = false;
        state.showFormSet.doorToDoor                      = false;
        state.showFormSet.kaasiDetails                    = false;

        state.showFormInput.billPayment.billerCode        = true;

        state.showFormInput.bankTransfer.bankName         = false;
        state.showFormInput.bankTransfer.bankBranch       = false;
        state.showFormInput.bankTransfer.beneficiaryType  = false;
        state.showFormInput.bankTransfer.bsbCode          = false;
        state.showFormInput.bankTransfer.iban             = false;
        state.showFormInput.bankTransfer.ifscCode         = false;
        state.showFormInput.bankTransfer.ifscBankBranch   = false;
        state.showFormInput.bankTransfer.sortCode         = false;
        state.showFormInput.bankTransfer.swiftCode        = false;

        state.showFormInput.provinceDetails.city          = true;
        state.showFormInput.provinceDetails.postcode      = true;
        state.showFormInput.provinceDetails.province      = true;

        state.showFormInput.root.beneficiaryName          = false;
        state.showFormInput.root.nickname                 = false;
        state.showFormInput.root.identificationType       = false;
        state.showFormInput.root.idTypeSelect             = false;
        state.showFormInput.root.identificationNo         = false;

        state.showFormInput.root.bankAccountNo            = false;
        state.showFormInput.root.walletNo                 = false;
        state.showFormInput.root.cnIdentificationNo       = false;
        state.showFormInput.root.dob                      = false;
        state.showFormInput.root.philGovServiceFullname   = false;
        state.showFormInput.root.philGovServiceNickname   = false;
        state.showFormInput.root.philGovServiceMemberType = false;
        state.showFormInput.root.refNo                    = false;

        state.showFormInput.kaasiDetails.state            = false;
        state.showFormInput.kaasiDetails.radioButton      = false;
        state.showFormInput.kaasiDetails.auBusiness       = false;
        state.showFormInput.kaasiDetails.nzBusiness       = false;

        state.showFormInput.contact.paymentPurpose        = false;
        state.showFormInput.contact.paymentPurposeOther   = false;
        state.showFormInput.contact.homeNo                = false;
        state.showFormInput.contact.mobileNo              = false;
        state.showFormInput.contact.email                 = false;

        state.cityList            = [];
        state.streetList          = [];
    },
    /* END OF RESET FORM DATA*/

    /* RESET DATASTORE */
    resetDataStore({ state, commit }, params) {
        if(params && params.isNewHomeCountry){
            state.transactionTypeName = ""
            state.transactionTypeId   = 0
        }
        state.billCorporationName = ""
        state.billCorporationId   = 0
        state.billerCode          = ""
        state.beneficiaryName     = ""
        state.nickname            = ""
        state.identificationType  = ""
        state.idTypeSelect        = ""
        state.idTypeSelectId      = 0
        state.identificationNo    = ""
        state.beneficiaryType     = ""
        state.beneficiaryTypeId   = 0
        state.bankName            = ""
        state.bankId              = 0
        state.bankBranch          = ""
        state.bankBranchId        = 0
        state.bsbCode             = ""
        state.iban                = ""
        state.swiftCode           = ""
        state.ifscCode            = ""
        state.ifscBankBranch      = ""
        state.sortCode            = ""
        state.collectionAgent     = ""
        state.collectionAgentId   = 0
        state.collectionPoint     = ""
        state.collectionPointId   = 0
        state.province            = ""
        state.provinceId          = 0
        state.city                = ""
        state.cityId              = 0
        state.street              = ""
        state.postcode            = ""
        state.locatingNote        = ""
        state.landmark            = ""
        state.bankAccountNo       = ""
        state.walletNo            = ""
        state.dateOfBirth         = ""
        state.philGovMemberType   = ""
        state.philGovMemberTypeId = 0
        state.refNo               = ""
        state.audAbn              = ""
        state.audAcn              = ""
        state.nzbn                = ""
        // DR-1845 code-inspection fix (Major) - was direct state mutation,
        // bypassing Vuex's mutation-commit mechanism (see resetFormData above
        // for the full rationale - same fix, mirrored here).
        commit('setBeneficiaryCountry', { id: 0, name: '' })
        commit('setBeneficiaryTownCity', '')
        state.paymentPurpose      = ""
        state.paymentPurposeId    = 0
        state.homeIDD             = 0
        state.homeIDDCode         = ""
        state.homeNo              = ""
        state.mobileIDD           = 0
        state.mobileIDDCode       = ""
        state.mobileNo            = ""
        state.email               = ""
        state.bankNotes           = ""
        state.isDataFilled        = false
        state.homeCountryId       = 0
        state.hostCountryId       = 0
        state.transactionTypeId   = 0
        state.homeCountryList       = []
        state.transactionTypeList   = []
        state.bankList              = []
        state.bankBranchList        = []
        state.idTypeList            = []
        state.paymentPurposeList    = []
        state.philGovMemberTypeList = []
        state.cityList              = []
        state.streetList            = []
        state.collectionAgentList   = []
        state.collectionPointList   = []
        state.billCorporationList   = []
        // state.countryCodeList       = []
        state.provinceList          = []
        if (state.forceRerenderKey) {state.forceRerenderKey.componentPaymentPurposeKey = 0}

        state.isDisplayBillPayment         = false
        state.isDisplayBankTransfer        = false
        state.isDisplayCollection          = false
        state.isDisplayProvinceDetails     = false
        state.isDisplayDoorToDoor          = false
        state.isDisplayKaasiDetails        = false
        state.isDisplayBillerCode          = false
        state.isDisplayBank                = false
        state.isDisplayBankBranch          = false
        state.isDisplayBeneficiaryType     = false
        state.isDisplayBsbCode             = false
        state.isDisplayIban                = false
        state.isDisplayIfscCode            = false
        state.isDisplayIfscBankBranch      = false
        state.isDisplaySortcode            = false
        state.isDisplaySwiftCode           = false
        state.isDisplayCity                = false
        state.isDisplayPostcode            = false
        state.isDisplayProvince            = false
        state.isDisplayBeneficiaryName     = false
        state.isDisplayNickname            = false
        state.isDisplayIdType              = false
        state.isDisplayIdTypeSelect        = false
        state.isDisplayIdNo                = false
        state.isDisplayAccountNo           = false
        state.isDisplayWalletNo            = false
        state.isDisplayCnIdNo              = false
        state.isDisplayDateOfBirth         = false
        state.isDisplayPhilGovFullName     = false
        state.isDisplayPhilGovNickname     = false
        state.isDisplayPhilGovMemberType   = false
        state.isDisplayRefNo               = false
        state.isDisplayAudBtState          = false
        state.isDisplayAudRadio            = false
        state.isDisplayAudBusiness         = false
        state.isDisplayNzBusiness          = false
        state.isDisplayPaymentPurpose      = false
        state.isDisplayPaymentPurposeOther = false
        state.isDisplayHomeNo              = false
        state.isDisplayMobileNo            = false
        state.isDisplayEmail               = false
        state.streetLabel                  = ""
        state.cityLabel                    = ""
        state.landmarkLabel                = ""
        state.postcodeLabel                = ""
    },
    /* END OF RESET DATASTORE */

    /* VALIDATE INPUT */
    validateInput({ state, dispatch }, inputEl) {
        let isValidInput           = false;
        let isHomeCountryValid     = false;
        let isTransactionTypeValid = false;

        // COUNTRY
        if(inputEl.id === "homeCountry") {
            isHomeCountryValid = state.homeCountryId > 0;
            let inputState = isHomeCountryValid ? true : i18n.t('beneficiary-country-error');
            dispatch('setValidateInputState', {name: inputEl, value: inputState});
        }
        // TRANSFER TYPE
        else if(inputEl.id === "transactionType") {
            isTransactionTypeValid = state.transactionTypeId != '';
            let inputState = isTransactionTypeValid ? true : i18n.t('beneficiary-service-type-error');
            dispatch('setValidateInputState', {name: inputEl, value: inputState});
        }
        // BILL CORPORATION NAME
        else if(inputEl.id == "billCorp") {
            dispatch('validateBillCorp', state.billCorporationId);
            isValidInput = state.isValidBillCorp;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // BENEFICIARY NAME || PHIL GOV SERVICE NAME
        else if(inputEl.id == "beneficiaryName" || inputEl.id == "philGovServiceFullname") {
            const params = {
                txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
                dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
                bankTypeId: 0,
                name      : inputEl.value
            }
            dispatch('validateBeneficiaryName', params);
            isValidInput = state.isValidBeneficiaryName;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // NICKNAME || PHIL GOV SERVICE NICKNAME
        else if(inputEl.id == "nickname" || inputEl.id == "philGovServiceNickname") {
            dispatch('validateNickname', inputEl.value);
            isValidInput = state.isValidNickname;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // IDENTIFICATION TYPE
        else if(inputEl.id == "identificationType") {
            const params = {
                countryId: state.homeCountryId,
                idType   : inputEl.value
            }
            dispatch('validateIdentificationType', params);
            isValidInput = state.isValidIdType;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // IDENTIFICATION TYPE SELECT
        else if(inputEl.id == "idTypeSelect") {
            dispatch('validateIdTypeSelect', state.idTypeSelectId);
            isValidInput = state.isValidIdTypeSelect;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // IDENTIFICATION NUMBER
        else if(inputEl.id == "identificationNo" || inputEl.id == "cnIdentificationNo") {
            const params = {
                countryId: state.homeCountryId,
                idNo     : inputEl.value
            }
            dispatch('validateIdentificationNo', params);
            isValidInput = state.isValidIdNo;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // BENEFICIARY TYPE
        else if(inputEl.id == "beneficiaryType" || (inputEl.childNodes[0] != undefined ? inputEl.childNodes[0].name == "radioReceiverType" : "")) {
            dispatch('validateBeneficiaryType', state.beneficiaryTypeId);
            isValidInput = state.isValidBeneficiaryType;

            if(inputEl.id != "beneficiaryType") {
                let radioErrorMsgTmp   = isValidInput == true ? "" : isValidInput
                dispatch('setRadioErrorMsg', radioErrorMsgTmp);
                let tmpIsDisplayErrorMsg = isValidInput == true ? false : true;
                dispatch('setIsDisplayErrorMsg', tmpIsDisplayErrorMsg);
            } else {
                dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
            }
        }
        // BANK NAME
        else if(inputEl.id == "bankName" || inputEl.id == "bankNameAutocomplete") {
            const params = {
                txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
                dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
                bankId    : state.bankId,
                bankTypeId: 0
            }
            dispatch('validateBank', params);
            isValidInput = state.isValidBank;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // BANK BRANCH
        else if(inputEl.id == "bankBranch" || inputEl.id == "bankBranchAutocomplete") {
            dispatch('validateBankBranch', state.bankBranchId);
            isValidInput = state.isValidBankBranch;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // BSB CODE
        else if(inputEl.id == "bsbCode") {
            const params = {
                countryId : state.homeCountryId,
                bsbCode : inputEl.value
            }

            dispatch('validateBsbCode', params);
            isValidInput = state.isValidBsbcode;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // IBAN
        else if(inputEl.id == "iban") {
            dispatch('validateIban', inputEl.value);
            isValidInput = state.isValidIban;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // SWIFT CODE
        else if(inputEl.id == "swiftCode") {
            dispatch('validateSwiftCode', inputEl.value);
            isValidInput = state.isValidSwiftcode;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // IFSC CODE
        else if(inputEl.id == "ifscCode") {
            dispatch('validateIfscCode', inputEl.value);
            isValidInput = state.isValidIfsccode;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // IFSC BANK BRANCH
        else if(inputEl.id == "ifscBankBranch") {
            dispatch('validateIfscBankBranch', inputEl.value);
            isValidInput = state.isValidIfscBankBranch;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // SORT CODE
        else if(inputEl.id == "sortCode") {
            dispatch('validateSortCode', inputEl.value);
            isValidInput = state.isValidSortcode;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // COLLECTION AGENT
        else if(inputEl.id == "collectionAgent" || inputEl.id == "collectionAgentAutocomplete") {
            dispatch('validateCollectionAgent', state.collectionAgentId);
            isValidInput = state.isValidCollectionAgent;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // COLLECTION POINT
        else if(inputEl.id == "collectionPoint") {
            dispatch('validateCollectionPoint', state.collectionPointId);
            isValidInput = state.isValidCollectionPoint;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // PROVINCE || STATE
        else if(inputEl.id == "province" || inputEl.id == "state") {
            dispatch('validateProvince', state.provinceId);
            isValidInput = state.isValidProvince;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // CITY || SUBURB
        else if(inputEl.id == "city" || inputEl.id == "suburb") {
            dispatch('validateCity', state.cityId);
            isValidInput = state.isValidCity;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // STREET || ADDRESS
        else if(inputEl.id == "street" || inputEl.id == "streetDropdown" || inputEl.id == "address") {
            dispatch('validateStreet', inputEl.value);
            isValidInput = state.isValidStreet;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // POSTCODE
        else if(inputEl.id == "postcode" || inputEl.id == "kaasiPostcode") {
            const params = {
                countryId    : state.homeCountryId,
                txTypeId     : state.isCreateBeneficiary ? state.transactionTypeId : 0,
                dmId         : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
                bankId       : state.bankId,
                bankTypeId   : 0,
                provinceId   : state.provinceId,
                cityId       : state.cityId,
                postcode     : inputEl.value,
                postcodeField: inputEl.id
            }
            if(state.homeCountryId == 13 || state.homeCountryId == 152){ // reset suburb when postcode changed
                dispatch('setCity', {id: 0, name: ''});
            }
            isValidInput = dispatch('finalValidatePostcode', params);
        }
        // BANK ACCOUNT NUMBER || WALLET NO
        else if(inputEl.id == "bankAccountNo" || inputEl.id == "walletNo") {
            const params = {
                countryId : state.homeCountryId,
                txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
                dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
                bankId    : state.bankId,
                bankTypeId: 0,
                accountNo : inputEl.value
            }

            const  isWallet  = (params.txTypeId == 102 || (params.dmId == 1 && params.bankTypeId == 2)) ? true : false

            dispatch('validateAccountNo', params);
            if(isWallet){
                isValidInput = state.isValidWalletNo;
            }else{
                isValidInput = state.isValidAccountNo;
            }
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // DATE OF BIRTH
        else if(inputEl.id == "dateOfBirth") {
            dispatch('validateDOB', inputEl.value);
            isValidInput = state.isValidDateOfBirth;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // PHIL GOV MEMBER TYPE
        else if(inputEl.id == "philGovMemberType") {
            dispatch('validatePhilGovMemberType', state.philGovMemberTypeId);
            isValidInput = state.isValidPhilGovMemberType;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // REF NO
        else if(inputEl.id == "refNo") {
            const params = {
                countryId : state.homeCountryId,
                txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
                dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
                bankTypeId: 0,
                refNo     : inputEl.value
            }
            dispatch('validateRefNote', params);
            isValidInput = state.isValidRefNo;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // ABN
        else if(inputEl.id == "audAbn") {
            dispatch('validateAbn', inputEl.value);
            isValidInput = state.isValidAbn;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // ACN
        else if(inputEl.id == "audAcn") {
            dispatch('validateAcn', inputEl.value);
            isValidInput = state.isValidAcn;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // NZBN
        else if(inputEl.id == "nzbn") {
            dispatch('validateNzbn', inputEl.value);
            isValidInput = state.isValidNzbn;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // DR-1845 - BENEFICIARY COUNTRY / TOWN-CITY
        else if(inputEl.id == "beneficiaryCountryId") {
            dispatch('validateBeneficiaryCountry', inputEl.value);
            isValidInput = state.isValidBeneficiaryCountry;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        else if(inputEl.id == "beneficiaryTownCity") {
            dispatch('validateBeneficiaryTownCity', inputEl.value);
            isValidInput = state.isValidBeneficiaryTownCity;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // PAYMENT PURPOSE
        else if(inputEl.id == "paymentPurpose" || inputEl.id == "paymentPurposeOther") {
            const params = {
                countryId   : state.homeCountryId,
                ppId        : state.paymentPurposeId,
                ppOther     : state.paymentPurposeOther,
                purposeField: inputEl.id
            }
            isValidInput = dispatch('finalValidatePaymentPurpose', params);
        }
        // HOME TELEPHONE
        else if(inputEl.id == 'homeNo') {
            const params = {
                countryId: state.homeCountryId,
                homeNo   : inputEl.value,
                homeIDD  : state.homeIDD
            }
            isValidInput = dispatch('finalValidateHomePhone', params);
        }
        // MOBILE TELEPHONE
        else if(inputEl.id == "mobileNo") {
            const params = {
                countryId : state.homeCountryId,
                txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
                dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
                bankTypeId: 0,
                mobileNo  : inputEl.value,
                mobileIDD : state.mobileIDD
            }
            isValidInput = dispatch('finalValidateMobilePhone', params);
        }
        // EMAIL
        else if(inputEl.id == "email") {
            const params = {
                countryId : state.homeCountryId,
                txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
                dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
                bankId    : state.bankId,
                bankTypeId: 0,
                email     : inputEl.value
            }
            dispatch('validateEmail', params);
            isValidInput = state.isValidEmail;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        // LANDMARK || DETAILS
        else if(inputEl.id == "landmark") {
            dispatch('validateLandmark', inputEl.value);
            isValidInput = state.isValidLandmark;
            dispatch('setValidateInputState', {name: inputEl.id, value: isValidInput});
        }
        else {
            isValidInput = true;
        }

        dispatch('setIsFormInputValid', isValidInput);
    },
    /* END OF VALIDATE INPUT */
    /* FINAL VALIDATION INPUT */
    finalValidatePostcode({ dispatch }, params) {
        dispatch('validatePostcode', params);
    },

    finalValidatePaymentPurpose({ dispatch, state }, params) {
        //let $$           = this.Dom7;
        let isValidInput = true;
        dispatch('validatePaymentPurpose', params);

        if(state.paymentPurposeId == -1) {
            // params.purposeField = "paymentPurposeOther"
            // $$('select[name="paymentPurpose"]').closest('li').addClass('mb-0');
            dispatch('setPaymentPurposeOther', params.ppOther);
        // } else {
            // $$('select[name="paymentPurpose"]').closest('li').removeClass('mb-0');
        }

        dispatch('displayPaymentPurposeOther', params);
        dispatch('setShowFormInputPaymentPurposeOther', state.isDisplayPaymentPurposeOther)

        isValidInput = state.isValidPaymentPurpose;
        dispatch('setValidateInputState', {name: params.purposeField, value: isValidInput});

        //return isValidInput;
    },

    finalValidateHomePhone({ dispatch, state }, params) {
        let isValidInput = true;
        dispatch('validateHomeNo', params);

        let homeNoTemp = params.homeNo != undefined ? params.homeNo.trim() : params.homeNo;
        if(homeNoTemp.length > 0) {
            dispatch('changeHomePhoneCode', params.homeIDD);
        }

        isValidInput = state.isValidHomeNo;
        dispatch('setValidateInputState', {name: 'homeNo', value: isValidInput});

        //return isValidInput;
    },

    finalValidateMobilePhone({ dispatch, state }, params) {
        let isValidInput = true;
        dispatch('validateMobileNo', params);

        let mobileNoTemp = params.mobileNo != undefined ? params.mobileNo.trim() : params.mobileNo;
        if(mobileNoTemp.length > 0) {
            dispatch('changeMobilePhoneCode', params.mobileIDD);
        }

        isValidInput = state.isValidMobileNo;
        dispatch('setValidateInputState', {name: 'mobileNo', value: isValidInput});

        //return isValidInput;
    },
    /* END OF FINAL VALIDATION INPUT */

    /* MOBILE & HOME PHONE */
    changeHomePhoneCode({ state, dispatch }, homeId) {
        for(let i=0; i < state.countryCodeList.length; i++) {
            let thisHomeCC = state.countryCodeList[i]
            if(thisHomeCC.id == homeId) {
                dispatch('setHomeIDD', {id: thisHomeCC.id, name: thisHomeCC.idd});
                break;
            }
        }
    },

    changeMobilePhoneCode({ state, dispatch }, mobileId) {
        for(let i=0; i < state.countryCodeList.length; i++) {
            let thisMobileCC = state.countryCodeList[i]
            if(thisMobileCC.id == mobileId) {
                dispatch('setMobileIDD', {id: thisMobileCC.id, name: thisMobileCC.idd});
                break;
            }
        }
    },
    /* END OF MOBILE & HOME PHONE */

    /* PROVINCE & CITY */
    changeProvince({ state, dispatch }, provinceId) {
        Vue.showPreloader();
        const pList         = state.provinceList;
        let isValidProvince = false;
        let isBankTransfer = (state.transactionTypeId == 1 || (state.deliveryMethodId == 1 && state.bankTypeId == 0)) ? true : false

        for(let i=0; i < pList.length; i++) {
            let thisPList = pList[i]
            if(thisPList.key == provinceId) {
                dispatch('setProvince', {id: provinceId, name: thisPList.value});
                isValidProvince = true;
                break;
            }
        }

        if(!isValidProvince) {
            dispatch('setProvince', {id: 0, name: ''});
        }
        /*
        const emptyCityList   = [];
        dispatch('setCityList', emptyCityList);
        dispatch('setCity', {id: 0, name: ''});
        dispatch('setValidateInputState', {name: 'city', value: false});
        */

        if(isBankTransfer && state.homeCountryId == 106){
            //console.log("clear district, street, and postcode")

            dispatch('setCityList', []);
            dispatch('setCity', {id: 0, name: ''});
            dispatch('setStreetList', []);
            dispatch('setStreet', '');
            dispatch('setPostcode', '');
        }

        if(state.provinceId > 0) {
            if(state.postcode.trim() == ""){ // LOAD ALL CITY or SUBURB BY PROVINCE or STATE
                dispatch('loadCityList', state.provinceId);
                if(state.cityId > 0){
                    dispatch('setCity', {id: state.cityId, name: state.city});
                }
            }else{
                Vue.showPreloader();
                if(state.homeCountryId == 13){ // 13 - AUSTRALIA
                    Vue.showPreloader();
                    if(state.isValidPostCode != undefined && state.isValidPostcode.cityId > 0) {
                        if(state.cityList.length == 1){ // set suburb
                            dispatch('setCity', {id: state.isValidPostcode.cityId, name: state.isValidPostcode.city});

                        }else{
                            for(let i=0; i < state.cityList.length; i++) {
                                let thisCList = state.cityList[i]
                                if(parseInt(thisCList.key) === parseInt(state.isValidPostcode.cityId)) {
                                    dispatch('setCity', {id: thisCList.key, name: thisCList.value});
                                    break;
                                }
                            }
                        }
                    }
                }

                //Vue.showPreloader();
                dispatch('setForceRerenderKey', 'suburb');
                Vue.hidePreloader();
            }
        }else{ // reset city / suburb
            const emptyCityList   = [];
            dispatch('setCityList', emptyCityList);
            dispatch('setCity', {id: 0, name: ''});
            dispatch('setValidateInputState', {name: 'city', value: false});
            dispatch('setForceRerenderKey', 'suburb');
            Vue.hidePreloader();
        }
    },

    async loadCityList({ state, dispatch }, provinceId) {
        const cityPromise = await this.$api.beneficiary.getCityList(state.homeCountryId, provinceId);
        await dispatch('setCityList', cityPromise);
        await dispatch('setAllCityList', cityPromise);
        await dispatch('setForceRerenderKey', 'suburb');
        // console.log("city/suburb loaded")
        Vue.hidePreloader()
        //dispatch('setShowPreloaderState', {name: "province", value: false});
    },

    changeCity({ state, dispatch }, cityId) {
        //console.log("CHANGE TO : "+cityId)
        let cList     = state.cityList;
        let isValidCity = false;
        Vue.showPreloader();
        // 13 - AUSTRALIA || 152 - NEW ZEALAND
        if(state.homeCountryId == 13 || state.homeCountryId == 152) {
            //console.log("cList change city: ", state.allCityList)
            cList = state.allCityList;
            for(let i=0; i < cList.length; i++) {
                let thisCList = cList[i]
                if(thisCList.value.toLowerCase() == cityId.toString().toLowerCase()) {
                    dispatch('setCity', {id: thisCList.key, name: thisCList.value});
                    isValidCity = true;

                    dispatch('loadPostCity', thisCList.key);
                    break;
                }
            }

            //console.log("isValidCity: "+isValidCity)
            if(!isValidCity) {
                dispatch('setCity', {id: 0, name: ''});
                dispatch('setValidateInputState', {name: 'suburb', value: false});
            }
        }else{
            for(let i=0; i < cList.length; i++) {
                let thisCList = cList[i]
                if(thisCList.key == cityId) {
                    dispatch('setCity', {id: cityId, name: thisCList.value});
                    isValidCity = true;

                    if(state.homeCountryId == 106){
                        dispatch('setStreetList', []);
                        dispatch('setStreet', '');
                        dispatch('setPostcode', '');

                        dispatch('loadStreetCity', thisCList.key);
                    }
                    break;
                }
            }

            if(!isValidCity) {
                dispatch('setCity', {id: 0, name: ''});
            }
        }
        Vue.hidePreloader();
    },

    changeStreet({ state, dispatch }, streetId) {
        Vue.showPreloader()
        const stList = state.streetList
        let isValidStreet = false;

        for(let i=0; i < stList.length; i++) {
            let thisStList = stList[i]
            if(thisStList.key == streetId) {
                dispatch('setStreet', thisStList.value);
                isValidStreet = true;

                if(state.homeCountryId == 106){
                    dispatch('loadPostStreet', thisStList.key);
                }
                break;
            }
        }

        if(!isValidStreet) {
            dispatch('setStreet', '');
        }
        Vue.hidePreloader()
    },

    async loadPostStreet({ state, dispatch }, streetId) {
        Vue.showPreloader();
        const postStreetPromise = await this.$api.beneficiary.getPostCodeByStreetId(streetId);
        //console.log("result loadPostStreet : ", postStreetPromise);

        const stList       = postStreetPromise;

        if(stList.length > 0) {
            let thisStreet  = stList[0];
            let postcodeVal = thisStreet.code.toString()
            //while (postcodeVal.length < 7) postcodeVal = "0" + postcodeVal;
            dispatch('setPostcode', postcodeVal);
        }

        let params = {
            countryId : state.homeCountryId,
            txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
            dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
            bankId    : state.bankId,
            bankTypeId: 0,
            provinceId: state.provinceId,
            cityId    : state.cityId,
            postcode  : state.postcode
        }

        Object.assign(params, {postcodeField: 'postcode'})
        dispatch('finalValidatePostcode', params)
        Vue.hidePreloader();
    },

    async loadPostCity({ state, dispatch }, cityId) {
        Vue.showPreloader();
        let postcodeField = "";
        let cityPromise;// = await this.$api.beneficiary.getCityById(cityId);
        if(state.homeCountryId == 106){ // 106 - JAPAN
            cityPromise = await this.$api.beneficiary.getPostCodeByStreetId(cityId);
        }else{
            cityPromise = await this.$api.beneficiary.getCityById(cityId);
        }
        const cList       = cityPromise;

        if(cList.length > 0) {
            let thisCity  = cList[0];
            dispatch('setPostcode', thisCity.code);
        }

        let params = {
            countryId : state.homeCountryId,
            txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
            dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
            bankId    : state.bankId,
            bankTypeId: 0,
            provinceId: state.provinceId,
            cityId    : state.cityId,
            postcode  : state.postcode
        }

        // 13 - AUSTRALIA || 152 - NEW ZEALAND
        postcodeField = (state.homeCountryId == 13 || state.homeCountryId == 152) ? "kaasiPostcode" : "postcode";
        Object.assign(params, {postcodeField: postcodeField})

        if(state.homeCountryId == 13 && state.isSuburbSelected && state.cityId > 0){ // skip re-validate postcode if suburb selected
            state.isValidPostcode.inputState = true;
            Vue.setInputState(postcodeField, true);
        }else{
            dispatch('finalValidatePostcode', params)
        }
        //dispatch('setShowPreloaderState', {name: "city", value: false});
        Vue.hidePreloader();
    },

    async loadStreetCity({ dispatch }, cityId) {
        Vue.showPreloader();
        const streetPromise = await this.$api.beneficiary.getStreetListByCity(cityId);
        //console.log("result loadStreetCity : ", streetPromise);
        await dispatch('setStreetList', streetPromise);
        Vue.hidePreloader();
    },
    /* END OF PROVINCE AND CITY */

    /* BILL CORP */
    changeBillCorp({ state, dispatch }, billCorpName) {
        const billCorpList  = state.billCorporationList;
        let isValidBillCorp = false;

        // console.log("billCorpList : ", billCorpList)

        Object.keys(billCorpList).forEach(key => {
            if(billCorpList[key].name.toLowerCase() == billCorpName.toLowerCase()) {
                dispatch('setBillCorp', {id: billCorpList[key].billCorporationId, name: billCorpList[key].name});
                dispatch('setBillerCode', billCorpList[key].codeList[0]);
                isValidBillCorp          = true;
                return;
            }
        })

        if(!isValidBillCorp) {
            dispatch('setBillCorp', {id: 0, name: ''});
            dispatch('setBillerCode', "");
            dispatch('setValidateInputState', {name: 'billerCode', value: false});
        }

        // if(state.billCorporationId > 0) {
            // dispatch('loadBillCorpDetails', state.billCorporationId);
        // }
    },

    async loadBillCorpDetails({ dispatch }, billCorporationId) {
        const billCorpPromise = await this.$api.beneficiary.getBillCorporationDetails(billCorporationId);
        const billCorp        = billCorpPromise
        dispatch('setBillerCode', billCorp.code);

        dispatch('setValidateInputState', {name: 'billerCode', value: false});
        dispatch('setShowPreloaderState', {name: "billCorp", value: false});
    },
    /* END OF BILL CORP */

    /* BANK & BANK BRANCH */
    changeBank({ state, dispatch }, bankId) {
        Vue.showPreloader()
        const bankList  = state.bankList;
        let isValidBank = false;

        Object.keys(bankList).forEach(key => {
            if(key == bankId) {
                dispatch('setBank', {id: key, name: bankList[key]});
                isValidBank   = true;
                dispatch('setValidateInputState', {name: "bankName", value: isValidBank});
                dispatch('setValidateInputState', {name: "bankNameAutocomplete", value: isValidBank});
                Vue.hidePreloader()
                return;
            }
        })

        if(!isValidBank) {
            dispatch('setBank', {id: 0, name: ''});
            dispatch('setBankBranch', {id: 0, name: ''});
            dispatch('setValidateInputState', {name: "bankName", value: false});
            dispatch('setValidateInputState', {name: "bankNameAutocomplete", value: false});
        }

        Vue.hidePreloader()
        dispatch('setForceRerenderKey', 'bankName');

        // 1 - BANK TRANSFER && (18 - BANGLADESH || 44 - CHINA || 95 - HONG KONG S.A.R. || 106 - JAPAN || 111 - S.KOREA || 145 - MYANMAR
        // || 148 - NEPAL || 161 - PAKISTAN || 197 - SRI LANKA || 208 - THAILAND || 222 - UNITED STATES || 236 - VIETNAM (USD) || 237 - CAMBODIA)
        if(state.transactionTypeId == 1 &&
            (state.homeCountryId == 18 || state.homeCountryId == 44 || state.homeCountryId == 95 || state.homeCountryId == 106 || state.homeCountryId == 111
                || state.homeCountryId == 145 || state.homeCountryId == 148 || state.homeCountryId == 161 || state.homeCountryId == 197 || state.homeCountryId == 208
                || state.homeCountryId == 222 || state.homeCountryId == 236 || state.homeCountryId == 237
            )
        ) {
            if(state.bankId > 0) {
                dispatch('loadBankBranch', state.bankId);
            }
        }

        // 101 - PHIL GOV SERVICE && 167 - PHILIPPINES
        if(state.transactionTypeId == 101 && state.homeCountryId == 167 && state.bankId > 0) {
            const params = {
                countryId : state.homeCountryId,
                txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
                dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
                bankId    : state.bankId,
                bankTypeId: 0
            }

            dispatch('displayAccountNo', params);
            dispatch('setBankAccountNoLabel', state.isDisplayAccountNo.label);

            dispatch('displayEmail', params);
            dispatch('setShowFormInputContactEmail', state.isDisplayEmail.isDisplay);
            dispatch('setEmailLabel', state.isDisplayEmail.label);
        }
    },

    async loadBankBranch({ state, dispatch }, bankId) {
        Vue.showPreloader()
        let emptyBankBranchList     = []
        dispatch('setBankBranchList', emptyBankBranchList);
        const bankBranchPromise = await this.$api.beneficiary.getBankBranchList(bankId);
        Vue.showPreloader()
        dispatch('setBankBranchList', bankBranchPromise);
        dispatch('setForceRerenderKey', 'bankBranch');
        Vue.hidePreloader()
        const bbList = Object.keys(state.bankBranchList)
        if(bbList.length == 1) {
            bbList.forEach(key => {
                dispatch('setBankBranch', {id: key, name: state.bankBranchList[key]});
                //dispatch('setValidateInputState', {name: 'bankName', value: false});
            })
        }
        dispatch('changeBankBranch', state.bankBranchId);
        //dispatch('setShowPreloaderState', {name: "bankName", value: false});
        Vue.hidePreloader()
    },

    changeBankBranch({ state, dispatch }, branchId) {
        Vue.showPreloader()
        const branchList      = state.bankBranchList;
        let isValidBankBranch = false;

        Object.keys(branchList).forEach(key => {
            if(key == branchId) {
                dispatch('setBankBranch', {id: key, name: branchList[key]});
                isValidBankBranch = true;
                dispatch('setValidateInputState', {name: 'bankBranch', value: isValidBankBranch});
                dispatch('setValidateInputState', {name: "bankBranchNameAutocomplete", value: isValidBankBranch});
                Vue.hidePreloader()
                return;
            }
        })

        if(!isValidBankBranch) {
            Vue.showPreloader()
            dispatch('setBankBranch', {id: 0, name: ''});
            Vue.hidePreloader()
        }
    },
    /* END OF BANK & BANK BRANCH */

    /* COLLECTION */
    changeCollectionAgent({ state, dispatch }, colAgentId) {
        Vue.showPreloader()
        const colAgentList  = state.collectionAgentList;
        let isValidColAgent = false;

        Object.keys(colAgentList).forEach(key => {
            if(key == colAgentId) {
                dispatch('setCollectionAgent', {id: key, name: colAgentList[key]});
                isValidColAgent        = true;
                dispatch('setValidateInputState', {name: 'collectionAgent', value: isValidColAgent});
                dispatch('setValidateInputState', {name: 'collectionAgentAutocomplete', value: isValidColAgent});

                return;
            }
        })

        if(!isValidColAgent) {
            dispatch('setCollectionAgent', {id: 0, name: ''});
            dispatch('setCollectionPoint', {id: 0, name: ''});
            dispatch('setProvince', {id: 0, name: ''});
            dispatch('setCity', {id: 0, name: ''});
            dispatch('setValidateInputState', {name: 'collectionPoint', value: false});
        }

        Vue.hidePreloader()
        if(state.collectionAgentId > 0) {
            dispatch('loadCollectionPointList', state.collectionAgentId);
        }
    },

    async loadCollectionPointList({ state, dispatch }, collectionAgentId) {
        Vue.showPreloader()
        dispatch('setCollectionPointList', []);
        const colPointPromise    = await this.$api.beneficiary.getCollectionPointList(collectionAgentId);
        dispatch('setCollectionPointList', colPointPromise);
        dispatch('setForceRerenderKey', 'collection');

        const params = {
            countryId : state.homeCountryId,
            txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
            dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
            bankTypeId: 0,
            caId      : state.collectionAgentId,
        }

        dispatch('changeCityLabel', params);
        dispatch('setCityLabel', state.cityLabel);

        dispatch('displayProvinceDetails', params);
        dispatch('setFormSetProvinceDetails', state.isDisplayProvinceDetails);

        dispatch('changeStreetLabel', params);
        dispatch('setStreetLabel', state.streetLabel);

        const colPointList = Object.keys(state.collectionPointList)
        if(colPointList.length == 1) {
            colPointList.forEach(key => {
                dispatch('setCollectionPoint', {id: key, name: state.collectionPointList[key]});
                dispatch('setValidateInputState', {name: 'collectionPoint', value: false});
            })
        }
        dispatch('changeCollectionPoint', state.collectionPointId);
        dispatch('setShowPreloaderState', {name: "collectionAgent", value: false});
        Vue.hidePreloader()
    },

    changeCollectionPoint({ state, dispatch }, colPointId) {
        const colPointList  = state.collectionPointList;
        let isValidColPoint = false;

        Object.keys(colPointList).forEach(key => {
            if(key == colPointId) {
                dispatch('setCollectionPoint', {id: key, name: colPointList[key]});
                isValidColPoint        = true;
                dispatch('setValidateInputState', {name: 'collectionPoint', value: isValidColPoint});
                return;
            }
        })

        if(!isValidColPoint) {
            dispatch('setCollectionPoint', {id: 0, name: ''});
        }
    },
    /* END OF COLLECTION */

    /* BENE TYPE & ID TYPE */
    changeBeneficiaryType({ state, dispatch }, typeId) {
        if(typeId == 1) {
            dispatch('setBeneficiaryType', {id: 1, name: i18n.t('general-text-individual')});
        } else if(typeId == 2) {
            dispatch('setBeneficiaryType', {id: 2, name: i18n.t('general-text-corporate')});

            // 13 - AUSTRALIA || 152 - NEW ZEALAND
            if(state.homeCountryId == 13 || state.homeCountryId == 152) {
                dispatch('setBeneficiaryType', {id: 2, name: i18n.t('general-text-business')});
            }
        }

        const params = {
            countryId : state.homeCountryId,
            txTypeId  : state.isCreateBeneficiary ? state.transactionTypeId : 0,
            dmId      : state.isCreateBeneficiary ? -1 : state.deliveryMethodId,
            bankTypeId: 0,
            beneTypeId: state.beneficiaryTypeId,
        }

        if(state.homeCountryId == 13) {
            dispatch('displayAudBusiness', params);
            dispatch('setFormInputKaasiDetails', {type: "business", value: state.isDisplayAudBusiness});
        } else if(state.homeCountryId == 152) {
            dispatch('displayNzBusiness', params);
            dispatch('setFormInputKaasiDetails', {type: "business", value: state.isDisplayNzBusiness});
        }
    },

    changeIdType({ state, dispatch }, idTypeId) {
        const itList = state.idTypeList;

        Object.keys(itList).forEach(key => {
            if(key.toLowerCase() == idTypeId) {
                dispatch('setIdTypeSelect', {id: key, name: itList[key]});
                return;
            }
        })
    },
    /* END OF BENE TYPE & ID TYPE */

    /* PAYMENT PURPOSE */
    changePaymentPurpose({ state, dispatch }, ppId) {
        for(let i=0; i < state.paymentPurposeList.length; i++) {
            let thisPP = state.paymentPurposeList[i]
            if(thisPP.key == ppId) {
                dispatch('setPaymentPurpose', {id: ppId, name: thisPP.value});
                dispatch('setValidateInputState', {name: "paymentPurpose", value: true});
                break;
            }
        }

        if(ppId == -1){
            dispatch('setShowFormInputPaymentPurposeOther', true);
        }else{
            dispatch('setPaymentPurposeOther', '');
            dispatch('setShowFormInputPaymentPurposeOther', false);
        }
    },
    /* END OF PAYMENT PURPOSE */

    changeDeliveryMethodToTransferType({ dispatch }, params) {
        if(params.dmId == 0) { // BILL PAYMENT
            dispatch('setTransactionType', {id: 4, name: i18n.t('general-text-tt-4')})
        } else if(params.dmId == 4) { // DOOR TO DOOR
            dispatch('setTransactionType', {id: 2, name: i18n.t('general-text-tt-2')})
        } else if(params.dmId == 6) { // CASH CARD
            if(params.countryId == 18) { // BANGLADESH - BKASH
                dispatch('setTransactionType', {id: 103, name: i18n.t('general-text-tt-103')})
            } else { // PHILIPPINES - BDO CASH CARD
                dispatch('setTransactionType', {id: 5, name: i18n.t('general-text-tt-5')})
            }
        } else if(params.dmId == 7) { // WALLET
            dispatch('setTransactionType', {id: 102, name: i18n.t('general-text-tt-102')})
        } else if(params.dmId == 8) { // PHIL GOV SERVICES
            dispatch('setTransactionType', {id: 101, name: i18n.t('general-text-tt-101')})
        } else if(params.dmId == 9) { // UPI
            dispatch('setTransactionType', {id: 6, name: i18n.t('general-text-tt-6')})
        } else {
            dispatch('setTransactionType', {id: params.dmId, name: i18n.t('general-text-tt-' + params.dmId)})
        }
    },

    /* FORCE RE-RENDER */
    setForceRerenderKey({ commit }, value) {
        commit('setForceRerenderKey', value);
    },
    /* END OF FORCE RE-RENDER */

    setValidateInputState({ commit }, params) {
        commit('setValidateInputState', params);
    },
    setShowPreloaderState({ commit }, params) {
        commit('setShowPreloaderState', params);
    },
    setFormSetBankTransfer({ commit }, value) {
        commit('setFormSetBankTransfer', value);
    },
    setFormSetProvinceDetails({ commit }, value) {
        commit('setFormSetProvinceDetails', value);
    },
    setFormSetBillPayment({ commit }, value) {
        commit('setFormSetBillPayment', value);
    },
    setFormSetCollection({ commit }, value) {
        commit('setFormSetCollection', value);
    },
    setFormInputKaasiDetails({ commit }, params) {
        commit('setFormInputKaasiDetails', params);
    },
    setBankList({ commit }, value) {
        commit('setBankList', value);
    },
    setBankBranchList({ commit }, value) {
        commit('setBankBranchList', value);
    },
    setHomeCountryList({ commit }, value) {
        commit('setHomeCountryList', value);
    },
    // DR-1845 - Beneficiary Country must offer every country, not just this
    // branch's remittance corridors (homeCountryList). Backed by the same
    // "complete country list" static-data endpoint retail/ops uses
    // (staticData.getCountryList(), NOT beneficiary.getCountryList()). Cached
    // in the store - only fetched once per session since it's effectively static.
    // DR-1845 (follow-up) - switched to getBeneficiaryCountryList(), which
    // applies the BENEFICIARY_COUNTRY_EXCLUDE_LIST server-side filter that
    // retail/mobile already apply - this dropdown was still showing excluded
    // countries after the exclude-list config was set up, since it was
    // calling the unfiltered getCountryList() (shared with the unrelated
    // Nationality dropdown, so that one stays untouched).
    async loadAllCountryList({ commit, state }) {
        if(state.allCountryList && state.allCountryList.length > 0) {
            return;
        }
        try {
            const countryPromise = await this.$api.staticData.getBeneficiaryCountryList();
            const list = (countryPromise || [])
                // DR-1845 - "(USD)" entries (Indonesia (USD), India (USD), ...) are
                // payment-corridor variants of the same real country, not distinct
                // beneficiary countries - drop them from this dropdown.
                .filter(c => c.countryName && c.countryName.indexOf('(USD)') === -1)
                .map(c => ({
                    id  : c.countryId,
                    name: c.countryName,
                    idd : c.countryIDD
                }));
            commit('setAllCountryList', list);
        } catch(e) {
            console.log(e)
        }
    },
    setHomeCountry({ commit }, params) {
        commit('setHomeCountry', params);
    },
    setHostCountry({ commit }, params) {
        commit('setHostCountry', params);
    },
    setTransactionTypeList({ commit }, value) {
        commit('setTransactionTypeList', value);
    },
    setTransactionType({ commit }, params) {
        commit('setTransactionType', params);
    },
    setDeliveryMethod({ commit }, params) {
        commit('setDeliveryMethod', params);
    },
    setDmExternalName({ commit }, params) {
        commit('setDmExternalName', params);
    },
    setHomeIDD({ commit }, params) {
        commit('setHomeIDD', params);
    },
    setMobileIDD({ commit }, value) {
        commit('setMobileIDD', value);
    },
    setBeneficiaryType({ commit }, params) {
        commit('setBeneficiaryType', params);
    },
    setBank({ commit }, params) {
        commit('setBank', params);
    },
    setBankNameLabel({ commit }, value) {
        commit('setBankNameLabel', value);
    },
    setBankNamePlaceholder({ commit }, value) {
        commit('setBankNamePlaceholder', value);
    },
    setBankTypeId({ commit }, value) {
        commit('setBankTypeId', value);
    },
    setBankBranch({ commit }, params) {
        commit('setBankBranch', params);
    },
    setBsbCode({ commit }, value) {
        commit('setBsbCode', value);
    },
    setIban({ commit }, value) {
        commit('setIban', value);
    },
    setSwiftCode({ commit }, value) {
        commit('setSwiftCode', value);
    },
    setIfscCode({ commit }, value) {
        commit('setIfscCode', value);
    },
    setIfscBankBranch({ commit }, value) {
        commit('setIfscBankBranch', value);
    },
    setShowFormInputIfscBankBranch({ commit }, value) {
        commit('setShowFormInputIfscBankBranch', value);
    },
    setSortCode({ commit }, value) {
        commit('setSortCode', value);
    },
    setBeneficiaryName({ commit }, value) {
        commit('setBeneficiaryName', value);
    },
    setNickname({ commit }, value) {
        commit('setNickname', value);
    },
    setIdentificationType({ commit }, value) {
        commit('setIdentificationType', value);
    },
    setIdTypeSelect({ commit }, value) {
        commit('setIdTypeSelect', value);
    },
    setIdTypeList({ commit }, value) {
        commit('setIdTypeList', value);
    },
    setIdentificationNo({ commit }, value) {
        commit('setIdentificationNo', value);
    },
    setBankAccountNoLabel({ commit }, value) {
        commit('setBankAccountNoLabel', value);
    },
    setEmailLabel({ commit }, value) {
        commit('setEmailLabel', value);
    },
    setShowFormInputContactEmail({ commit }, value) {
        commit('setShowFormInputContactEmail', value);
    },
    setBankAccountNo({ commit }, value) {
        commit('setBankAccountNo', value);
    },
    setWalletNo({ commit }, value) {
        commit('setWalletNo', value);
    },
    setPaymentPurpose({ commit }, params) {
        commit('setPaymentPurpose', params);
    },
    setPaymentPurposeOther({ commit }, value) {
        commit('setPaymentPurposeOther', value);
    },
    setPaymentPurposeList({ commit }, value) {
        commit('setPaymentPurposeList', value);
    },
    setPhilGovMemberTypeList({ commit }, value) {
        commit('setPhilGovMemberTypeList', value);
    },
    setPhilGovMemberType({ commit }, params) {
        commit('setPhilGovMemberType', params);
    },
    setDateOfBirth({ commit }, value) {
        commit('setDateOfBirth', value);
    },
    setRefNo({ commit }, value) {
        commit('setRefNo', value);
    },
    setStreetList({ commit }, value) {
        commit('setStreetList', value);
    },
    setCityList({ commit }, value) {
        commit('setCityList', value);
    },
    setAllCityList({ commit }, value) {
        commit('setAllCityList', value);
    },
    setCity({ commit }, params) {
        commit('setCity', params);
    },
    setCollectionAgentList({ commit }, value) {
        commit('setCollectionAgentList', value);
    },
    setCollectionAgent({ commit }, params) {
        commit('setCollectionAgent', params);
    },
    setCollectionPointList({ commit }, value) {
        commit('setCollectionPointList', value);
    },
    setCollectionPoint({ commit }, params) {
        commit('setCollectionPoint', params);
    },
    setBillCorp({ commit }, params) {
        commit('setBillCorp', params);
    },
    setBillerCode({ commit }, value) {
        commit('setBillerCode', value);
    },
    setBillCorporationList({ commit }, value) {
        commit('setBillCorporationList', value);
    },
    setCountryCodeList({ commit }, value) {
        commit('setCountryCodeList', value);
    },
    setProvinceList({ commit }, value) {
        commit('setProvinceList', value);
    },
    setProvince({ commit }, params) {
        commit('setProvince', params);
    },
    setStreet({ commit }, value) {
        commit('setStreet', value);
    },
    setPostcode({ commit }, value) {
        commit('setPostcode', value);
    },
    setStreetLabel({ commit }, value) {
        commit('setStreetLabel', value);
    },
    setCityLabel({ commit }, value) {
        commit('setCityLabel', value);
    },
    setLandmarkLabel({ commit }, value) {
        commit('setLandmarkLabel', value);
    },
    setPostcodeLabel({ commit }, value) {
        commit('setPostcodeLabel', value);
    },
    setLocatingNote({ commit }, value) {
        commit('setLocatingNote', value);
    },
    setLandmark({ commit }, value) {
        commit('setLandmark', value);
    },
    setAudAbn({ commit }, value) {
        commit('setAudAbn', value);
    },
    setAudAcn({ commit }, value) {
        commit('setAudAcn', value);
    },
    setNzbn({ commit }, value) {
        commit('setNzbn', value);
    },
    setBeneficiaryCountry({ commit }, payload) {
        commit('setBeneficiaryCountry', payload);
    },
    setBeneficiaryTownCity({ commit }, value) {
        commit('setBeneficiaryTownCity', value);
    },
    // DR-1845 - reads whether Beneficiary Country / Town-City is mandatory for the
    // given (home/destination) country: the global toggle AND the per-country flag.
    // Called whenever the destination country changes.
    async loadAddressConfig({ commit }, countryId) {
        try {
            const config = await this.$api.beneficiary.getBeneficiaryAddressConfig(countryId);
            commit('setAddressConfig', {
                addressHardMandatory     : !config || config.addressHardMandatory !== false,
                isCountryAddressMandatory: !!config && config.isCountryAddressMandatory === true
            });
        } catch(e) {
            console.log(e)
            // Fail safe to hard-mandatory - a config-lookup hiccup must never silently
            // drop the AML screening requirement.
            commit('setAddressConfig', { addressHardMandatory: true, isCountryAddressMandatory: false });
        }
    },
    validateBeneficiaryCountry({ commit, state }, value) {
        let isValidInput = true;
        let msg          = i18n.t('beneficiary-bene-country-error');

        if(state.addressHardMandatory && state.isCountryAddressMandatory) {
            isValidInput = value != undefined && parseInt(value) > 0;
        }

        commit('loadIsValidBeneficiaryCountry', isValidInput ? true : msg);
    },
    validateBeneficiaryTownCity({ commit, state }, value) {
        let townCity     = value != undefined ? value.trim() : value;
        let isValidInput = true;
        let msg          = i18n.t('beneficiary-town-city-error');

        if(state.addressHardMandatory && state.isCountryAddressMandatory) {
            isValidInput = townCity != undefined && townCity.length > 0;
        }

        commit('loadIsValidBeneficiaryTownCity', isValidInput ? true : msg);
    },
    setRadioErrorMsg({ commit }, value) {
        commit('setRadioErrorMsg', value);
    },
    setIsDisplayErrorMsg({ commit }, value) {
        commit('setIsDisplayErrorMsg', value);
    },
    setHomeNo({ commit }, value) {
        commit('setHomeNo', value);
    },
    setMobileNo({ commit }, value) {
        commit('setMobileNo', value);
    },
    setSmsNotification({ commit }, value) {
        commit('setSmsNotification', value);
    },
    setEmail({ commit }, value) {
        commit('setEmail', value);
    },
    setEmailNotification({ commit }, value) {
        commit('setEmailNotification', value);
    },
    setShowFormInputPaymentPurposeOther({ commit }, value) {
        commit('setShowFormInputPaymentPurposeOther', value);
    },
    setIsFormInputValid({ commit }, value) {
        commit('setIsFormInputValid', value);
    },
    setIsCreateBeneficiary({ commit }, value) {
        commit('setIsCreateBeneficiary', value);
    },
    setIsSuburbSelected({ commit }, value) {
        commit('setIsSuburbSelected', value);
    },
    setNewBeneficiaryId({ commit }, value) {
        commit('setNewBeneficiaryId', value);
    },
    setIsAutocomplete({ commit }, value) {
        commit('setIsAutocomplete', value);
    },
    setIsDropdown({ commit }, value) {
        commit('setIsDropdown', value);
    },
}

const mutations = {
    resetBeneficiaryState (state) {
        const countryCodeList = state.countryCodeList;
        Object.assign(state, getDefaultState())
        state.countryCodeList = countryCodeList;
    },
    setValidateInputState(state, payload){
        state.validateInputState.name = payload.name;
        state.validateInputState.value = payload.value;
    },
    setForceRerenderKey(state, value){
        if(value == "paymentPurpose"){
            state.forceRerenderKey.componentPaymentPurposeKey += 1;
        }else if(value == "state"){
            state.forceRerenderKey.componentAudBtStateKey += 1;
        }else if(value == "suburb"){
            state.forceRerenderKey.componentAudBtSuburbKey += 1;
        }else if(value == "bankName"){
            state.forceRerenderKey.componentBTBankNameKey += 1;
        }else if(value == "bankBranch"){
            state.forceRerenderKey.componentBTBankBranchKey += 1;
        }else if(value == "province"){
            state.forceRerenderKey.componentProvinceDetailsKey += 1;
        }else if(value == "collection"){
            state.forceRerenderKey.componentCollectionKey += 1;
        }
    },
    setShowPreloaderState(state, payload){
        state.showPreloaderState.name = payload.name;
        state.showPreloaderState.value = payload.value;
    },
    setFormSetBankTransfer(state, payload){
        state.showFormSet.bankTransfer = payload
    },
    setFormSetProvinceDetails(state, payload){
        state.showFormSet.provinceDetails = payload
    },
    setFormSetBillPayment(state, payload){
        state.showFormSet.billPayment = payload
    },
    setFormSetCollection(state, payload){
        state.showFormSet.collection = payload
    },
    setFormInputKaasiDetails(state, payload){
        if(payload.type == "business"){
            if(state.homeCountryId == 13) {
                state.showFormInput.kaasiDetails.auBusiness = payload.value
            } else if(state.homeCountryId == 152) {
                state.showFormInput.kaasiDetails.nzBusiness = payload.value
            }
        }else if(payload.type == "radioButton"){
            state.showFormInput.kaasiDetails.radioButton = payload.value
        }
    },
    setBankList(state, payload) {
        state.bankList = payload;
    },
    setBankBranchList(state, payload) {
        state.bankBranchList = payload;
    },
    setHomeCountryList(state, payload) {
        state.homeCountryList = payload;
    },
    setAllCountryList(state, payload) {
        state.allCountryList = payload;
    },
    setHomeCountry(state, payload){
        state.homeCountryId = payload.id;
        state.homeCountryIdd = payload.idd;
        state.homeCountryName = payload.name;
    },
    setHostCountry(state, payload){
        state.hostCountryId = payload.id;
        state.hostCountryName = payload.name;
    },
    setTransactionTypeList(state, payload) {
        state.transactionTypeList = payload;
    },
    setTransactionType(state, payload){
        state.transactionTypeId = payload.id;
        state.transactionTypeName = payload.name;
    },
    setDeliveryMethod(state, payload){
        state.deliveryMethodId = payload.id;
        state.deliveryMethod = payload.name;
    },
    setDmExternalName(state, payload) {
        state.dmExternalName = payload;
    },
    setHomeIDD(state, payload) {
        state.homeIDD = payload.id;
        state.homeIDDCode = payload.name;
    },
    setMobileIDD(state, payload) {
        state.mobileIDD = payload.id;
        state.mobileIDDCode = payload.name;
    },
    setBeneficiaryType(state, payload){
        state.beneficiaryTypeId = payload.id;
        state.beneficiaryType = payload.name;
    },
    setBank(state, payload){
        state.bankId = payload.id;
        state.bankName = payload.name;
    },
    setBankNameLabel(state, payload){
        state.bankNameLabel = payload;
    },
    setBankNamePlaceholder(state, payload){
        state.bankNamePlaceholder = payload;
    },
    setBankTypeId(state, payload){
        state.bankTypeId = payload;
    },
    setBankBranch(state, payload){
        state.bankBranchId = payload.id;
        state.bankBranch = payload.name;
    },
    setBsbCode(state, payload){
        state.bsbCode = payload;
    },
    setIban(state, payload){
        state.iban = payload;
    },
    setSwiftCode(state, payload){
        state.swiftCode = payload;
    },
    setIfscCode(state, payload){
        state.ifscCode = payload;
    },
    setIfscBankBranch(state, payload){
        state.ifscBankBranch = payload;
    },
    setShowFormInputIfscBankBranch(state, payload){
        state.showFormInput.bankTransfer.ifscBankBranch = payload;
    },
    setSortCode(state, payload){
        state.sortCode = payload;
    },
    setBeneficiaryName(state, payload){
        state.beneficiaryName = payload;
    },
    setNickname(state, payload){
        state.nickname = payload;
    },
    setIdentificationType(state, payload){
        state.identificationType = payload;
    },
    setIdTypeSelect(state, payload){
        state.idTypeSelectId = payload.id;
        state.idTypeSelect = payload.name;
    },
    setIdTypeList(state, payload) {
        state.idTypeList = payload;
    },
    setIdentificationNo(state, payload) {
        state.identificationNo = payload;
    },
    setBankAccountNoLabel(state, payload){
        state.bankAccountNoLabel = payload;
    },
    setEmailLabel(state, payload){
        state.emailLabel = payload;
    },
    setShowFormInputPaymentPurposeOther(state, payload){
        state.showFormInput.contact.paymentPurposeOther = payload;
    },
    setShowFormInputContactEmail(state, payload){
        state.showFormInput.contact.email = payload;
    },
    setBankAccountNo(state, payload){
        state.bankAccountNo = payload;
    },
    setWalletNo(state, payload){
        state.walletNo = payload;
    },
    setPaymentPurpose(state, payload){
        state.paymentPurposeId = payload.id;
        state.paymentPurpose = payload.name;
    },
    setPaymentPurposeOther(state, payload) {
        state.paymentPurposeOther = payload;
    },
    setPaymentPurposeList(state, payload) {
        state.paymentPurposeList = payload;
    },
    setPhilGovMemberTypeList(state, payload) {
        state.philGovMemberTypeList = payload;
    },
    setPhilGovMemberType(state, payload) {
        state.philGovMemberTypeId = payload.id;
        state.philGovMemberType = payload.name;
    },
    setDateOfBirth(state, payload) {
        state.dateOfBirth = payload;
    },
    setRefNo(state, payload) {
        state.refNo = payload;
    },
    setStreetList(state, payload) {
        state.streetList = payload;
    },
    setCityList(state, payload) {
        state.cityList = payload;
    },
    setAllCityList(state, payload) {
        state.allCityList = payload;
    },
    setCity(state, payload) {
        state.cityId = payload.id;
        state.city = payload.name;
    },
    setCollectionAgentList(state, payload) {
        state.collectionAgentList = payload;
    },
    setCollectionAgent(state, payload) {
        state.collectionAgentId = payload.id;
        state.collectionAgent = payload.name;
    },
    setCollectionPointList(state, payload) {
        state.collectionPointList = payload;
    },
    setCollectionPoint(state, payload) {
        state.collectionPointId = payload.id;
        state.collectionPoint = payload.name;
    },
    setBillCorp(state, payload) {
        state.billCorporationId = payload.id;
        state.billCorporationName = payload.name;
    },
    setBillerCode(state, payload) {
        state.billerCode = payload;
    },
    setBillCorporationList(state, payload) {
        state.billCorporationList = payload;
    },
    setCountryCodeList(state, payload) {

        payload.forEach(function(item,i){
            if(item.id === 189){
                payload.splice(i, 1);
                payload.unshift(item);
            }
        });

        state.countryCodeList = payload;
    },
    setProvinceList(state, payload) {
        state.provinceList = payload;
    },
    setProvince(state, payload) {
        state.provinceId = payload.id;
        state.province = payload.name;
    },
    setStreet(state, payload) {
        state.street = payload;
    },
    setPostcode(state, payload) {
        state.postcode = payload;
    },
    setStreetLabel(state, payload) {
        state.streetLabel = payload;
    },
    setCityLabel(state, payload) {
        state.cityLabel = payload;
    },
    setLandmarkLabel(state, payload) {
        state.landmarkLabel = payload;
    },
    setPostcodeLabel(state, payload) {
        state.postcodeLabel = payload;
    },
    setLocatingNote(state, payload) {
        state.locatingNote = payload;
    },
    setLandmark(state, payload) {
        state.landmark = payload;
    },
    setAudAbn(state, payload) {
        state.audAbn = payload;
    },
    setAudAcn(state, payload) {
        state.audAcn = payload;
    },
    setNzbn(state, payload) {
        state.nzbn = payload;
    },
    setBeneficiaryCountry(state, payload) {
        state.beneficiaryCountryId   = payload.id;
        state.beneficiaryCountryName = payload.name;
    },
    setBeneficiaryTownCity(state, payload) {
        state.beneficiaryTownCity = payload;
    },
    setAddressConfig(state, payload) {
        state.addressHardMandatory      = payload.addressHardMandatory;
        state.isCountryAddressMandatory = payload.isCountryAddressMandatory;
    },
    loadIsValidBeneficiaryCountry(state, isValid) {
        state.isValidBeneficiaryCountry = isValid;
    },
    loadIsValidBeneficiaryTownCity(state, isValid) {
        state.isValidBeneficiaryTownCity = isValid;
    },
    setRadioErrorMsg(state, payload) {
        state.radioErrorMsg = payload;
    },
    setIsDisplayErrorMsg(state, payload) {
        state.isDisplayErrorMsg = payload;
    },
    setHomeNo(state, payload) {
        state.homeNo = payload;
    },
    setMobileNo(state, payload) {
        state.mobileNo = payload;
    },
    setSmsNotification(state, payload) {
        state.smsNotification = payload;
    },
    setEmail(state, payload) {
        state.email = payload;
    },
    setEmailNotification(state, payload) {
        state.emailNotification = payload;
    },
    setIsFormInputValid(state, payload) {
        state.isFormInputValid = payload;
    },
    setIsCreateBeneficiary(state, payload) {
        state.isCreateBeneficiary = payload;
    },
    setIsSuburbSelected(state, payload) {
        state.isSuburbSelected = payload;
    },
    setNewBeneficiaryId(state, payload) {
        state.newBeneficiaryId = payload;
    },
    setIsAutocomplete(state, payload) {
        state.isAutocomplete = payload;
    },
    setIsDropdown(state, payload) {
        state.isDropdown = payload;
    },
    loadIsDisplayBillPayment(state, isDisplayBillPayment) {
        state.isDisplayBillPayment = isDisplayBillPayment;
    },
    loadIsDisplayBankTransfer(state, isDisplayBankTransfer) {
        state.isDisplayBankTransfer = isDisplayBankTransfer;
    },
    loadIsDisplayCollection(state, isDisplayCollection) {
        state.isDisplayCollection = isDisplayCollection;
    },
    loadIsDisplayProvinceDetails(state, isDisplayProvinceDetails) {
        state.isDisplayProvinceDetails = isDisplayProvinceDetails;
    },
    loadIsDisplayDoorToDoor(state, isDisplayDoorToDoor) {
        state.isDisplayDoorToDoor = isDisplayDoorToDoor;
    },
    loadIsDisplayKaasiDetails(state, isDisplayKaasiDetails) {
        state.isDisplayKaasiDetails = isDisplayKaasiDetails;
    },
    loadIsDisplayBillerCode(state, isDisplayBillerCode) {
        state.isDisplayBillerCode = isDisplayBillerCode;
    },
    loadIsDisplayBank(state, isDisplayBank) {
        state.isDisplayBank = isDisplayBank;
    },
    loadIsDisplayBankBranch(state, isDisplayBankBranch) {
        state.isDisplayBankBranch = isDisplayBankBranch;
    },
    loadIsDisplayBeneficiaryType(state, isDisplayBeneficiaryType) {
        state.isDisplayBeneficiaryType = isDisplayBeneficiaryType;
    },
    loadIsDisplayBsbCode(state, isDisplayBsbCode) {
        state.isDisplayBsbCode = isDisplayBsbCode;
    },
    loadIsDisplayIban(state, isDisplayIban) {
        state.isDisplayIban = isDisplayIban;
    },
    loadIsDisplayIfscCode(state, isDisplayIfscCode) {
        state.isDisplayIfscCode = isDisplayIfscCode;
    },
    loadIsDisplayIfscBankBranch(state, isDisplayIfscBankBranch) {
        state.isDisplayIfscBankBranch = isDisplayIfscBankBranch;
    },
    loadIsDisplaySortCode(state, isDisplaySortcode) {
        state.isDisplaySortcode = isDisplaySortcode;
    },
    loadIsDisplaySwiftCode(state, isDisplaySwiftCode) {
        state.isDisplaySwiftCode = isDisplaySwiftCode;
    },
    loadIsDisplayCity(state, isDisplayCity) {
        state.isDisplayCity = isDisplayCity;
    },
    loadIsDisplayPostcode(state, isDisplayPostcode) {
        state.isDisplayPostcode = isDisplayPostcode;
    },
    loadIsDisplayProvince(state, isDisplayProvince) {
        state.isDisplayProvince = isDisplayProvince;
    },
    loadIsDisplayBeneficiaryName(state, isDisplayBeneficiaryName) {
        state.isDisplayBeneficiaryName = isDisplayBeneficiaryName;
    },
    loadIsDisplayNickname(state, isDisplayNickname) {
        state.isDisplayNickname = isDisplayNickname;
    },
    loadIsDisplayIdType(state, isDisplayIdType) {
        state.isDisplayIdType = isDisplayIdType;
    },
    loadIsDisplayIdTypeSelect(state, isDisplayIdTypeSelect) {
        state.isDisplayIdTypeSelect = isDisplayIdTypeSelect;
    },
    loadIsDisplayIdNo(state, isDisplayIdNo) {
        state.isDisplayIdNo = isDisplayIdNo;
    },
    loadIsDisplayAccountNo(state, isDisplayAccountNo) {
        state.isDisplayAccountNo = isDisplayAccountNo;
    },
    loadIsDisplayWalletNo(state, isDisplayWalletNo) {
        state.isDisplayWalletNo = isDisplayWalletNo;
    },
    loadIsDisplayCnIdNo(state, isDisplayCnIdNo) {
        state.isDisplayCnIdNo = isDisplayCnIdNo;
    },
    loadIsDisplayDateOfBirth(state, isDisplayDateOfBirth) {
        state.isDisplayDateOfBirth = isDisplayDateOfBirth;
    },
    loadIsDisplayPhilGovFullName(state, isDisplayPhilGovFullName) {
        state.isDisplayPhilGovFullName = isDisplayPhilGovFullName;
    },
    loadIsDisplayPhilGovNickname(state, isDisplayPhilGovNickname) {
        state.isDisplayPhilGovNickname = isDisplayPhilGovNickname;
    },
    loadIsDisplayPhilGovMemberType(state, isDisplayPhilGovMemberType) {
        state.isDisplayPhilGovMemberType = isDisplayPhilGovMemberType;
    },
    loadIsDisplayRefNo(state, isDisplayRefNo) {
        state.isDisplayRefNo = isDisplayRefNo;
    },
    loadIsDisplayAudBtState(state, isDisplayAudBtState) {
        state.isDisplayAudBtState = isDisplayAudBtState;
    },
    loadIsDisplayAudRadio(state, isDisplayAudRadio) {
        state.isDisplayAudRadio = isDisplayAudRadio;
    },
    loadIsDisplayAudBusiness(state, isDisplayAudBusiness) {
        state.isDisplayAudBusiness = isDisplayAudBusiness;
    },
    loadIsDisplayNzBusiness(state, isDisplayNzBusiness) {
        state.isDisplayNzBusiness = isDisplayNzBusiness;
    },
    loadIsDisplayPaymentPurpose(state, isDisplayPaymentPurpose) {
        state.isDisplayPaymentPurpose = isDisplayPaymentPurpose;
    },
    loadIsDisplayPaymentPurposeOther(state, isDisplayPaymentPurposeOther) {
        state.isDisplayPaymentPurposeOther = isDisplayPaymentPurposeOther;
    },
    loadIsDisplayHomeNo(state, isDisplayHomeNo) {
        state.isDisplayHomeNo = isDisplayHomeNo;
    },
    loadIsDisplayMobileNo(state, isDisplayMobileNo) {
        state.isDisplayMobileNo = isDisplayMobileNo;
    },
    loadIsDisplayEmail(state, isDisplayEmail) {
        state.isDisplayEmail = isDisplayEmail;
    },
    loadStreetLabel(state, streetLabel) {
        state.streetLabel = streetLabel;
    },
    loadCityLabel(state, cityLabel) {
        state.cityLabel = cityLabel;
    },
    loadLandmarkLabel(state, landmarkLabel) {
        state.landmarkLabel = landmarkLabel;
    },
    loadPostcodeLabel(state, postcodeLabel) {
        state.postcodeLabel = postcodeLabel;
    },
    loadIsValidBillCorp(state, isValidBillCorp) {
        state.isValidBillCorp = isValidBillCorp;
    },
    loadIsValidBeneficiaryName(state, isValidBeneficiaryName) {
        state.isValidBeneficiaryName = isValidBeneficiaryName;
    },
    loadIsValidNickname(state, isValidNickname) {
        state.isValidNickname = isValidNickname;
    },
    loadIsValidIdType(state, isValidIdType) {
        state.isValidIdType = isValidIdType;
    },
    loadIsValidIdTypeSelect(state, isValidIdTypeSelect) {
        state.isValidIdTypeSelect = isValidIdTypeSelect;
    },
    loadIsValidIdNo(state, isValidIdNo) {
        state.isValidIdNo = isValidIdNo;
    },
    loadIsValidBeneficiaryType(state, isValidBeneficiaryType) {
        state.isValidBeneficiaryType = isValidBeneficiaryType;
    },
    loadIsValidBank(state, isValidBank) {
        state.isValidBank = isValidBank;
    },
    loadIsValidBankBranch(state, isValidBankBranch) {
        state.isValidBankBranch = isValidBankBranch;
    },
    loadIsValidBsbcode(state, isValidBsbcode) {
        state.isValidBsbcode = isValidBsbcode;
    },
    loadIsValidIban(state, isValidIban) {
        state.isValidIban = isValidIban;
    },
    loadIsValidSwiftcode(state, isValidSwiftcode) {
        state.isValidSwiftcode = isValidSwiftcode;
    },
    loadIsValidIfsccode(state, isValidIfsccode) {
        state.isValidIfsccode = isValidIfsccode;
    },
    loadIsValidIfscBankBranch(state, isValidIfscBankBranch) {
        state.isValidIfscBankBranch = isValidIfscBankBranch;
    },
    loadIsValidSortcode(state, isValidSortcode) {
        state.isValidSortcode = isValidSortcode;
    },
    loadIsValidCollectionAgent(state, isValidCollectionAgent) {
        state.isValidCollectionAgent = isValidCollectionAgent;
    },
    loadIsValidCollectionPoint(state, isValidCollectionPoint) {
        state.isValidCollectionPoint = isValidCollectionPoint;
    },
    loadIsValidProvince(state, isValidProvince) {
        state.isValidProvince = isValidProvince;
    },
    loadIsValidCity(state, isValidCity) {
        state.isValidCity = isValidCity;
    },
    loadIsValidStreet(state, isValidStreet) {
        state.isValidStreet = isValidStreet;
    },
    loadIsValidLandmark(state, isValidLandmark) {
        state.isValidLandmark = isValidLandmark;
    },
    loadIsValidPostcode(state, isValidPostcode) {
        state.isValidPostcode = isValidPostcode;
    },
    loadIsValidAccountNo(state, isValidAccountNo) {
        state.isValidAccountNo = isValidAccountNo;
    },
    loadIsValidWalletNo(state, isValidWalletNo) {
        state.isValidWalletNo = isValidWalletNo;
    },
    loadIsValidDateOfBirth(state, isValidDateOfBirth) {
        state.isValidDateOfBirth = isValidDateOfBirth;
    },
    loadIsValidPhilGovMemberType(state, isValidPhilGovMemberType) {
        state.isValidPhilGovMemberType = isValidPhilGovMemberType;
    },
    loadIsValidRefNo(state, isValidRefNo) {
        state.isValidRefNo = isValidRefNo;
    },
    loadIsValidAbn(state, isValidAbn) {
        state.isValidAbn = isValidAbn;
    },
    loadIsValidAcn(state, isValidAcn) {
        state.isValidAcn = isValidAcn;
    },
    loadIsValidNzbn(state, isValidNzbn) {
        state.isValidNzbn = isValidNzbn;
    },
    loadIsValidPaymentPurpose(state, isValidPaymentPurpose) {
        state.isValidPaymentPurpose = isValidPaymentPurpose;
    },
    loadIsValidHomeNo(state, isValidHomeNo) {
        state.isValidHomeNo = isValidHomeNo;
    },
    loadIsValidMobileNo(state, isValidMobileNo) {
        state.isValidMobileNo = isValidMobileNo;
    },
    loadIsValidEmail(state, isValidEmail) {
        state.isValidEmail = isValidEmail;
    },
    loadCheckPreventOnlySpecial(state, isValidCheckOnlySpecial) {
        state.isValidCheckOnlySpecial = isValidCheckOnlySpecial;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}